'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
var tooltip = require('./tooltip-e34b5863.js');
var defaultTheme = require('./defaultTheme-068d5ee4.js');
var withStyles = require('./withStyles-b393a9eb.js');
var capitalize = require('./capitalize-4d39daf3.js');
var styled = require('styled-components');
require('react-helmet');
var element$1 = require('./element-2cae4d89.js');
var element = require('./element-2d0b0a9a.js');
var elementOutline = require('./element-outline-e92b8ea2.js');
var iconButtons = require('./icon-buttons-442762e4.js');
var hooks_useElementId = require('./hooks/use-element-id/index.js');
var hooks_useRandomId = require('./hooks/use-random-id/index.js');
var hooks_useWrappedFunction = require('./hooks/use-wrapped-function/index.js');
var iconLibrary_notificationIcons_errorLight = require('./icon-library/notification-icons/error-light/index.js');
var component = require('./component-21a580e6.js');
var colorPalette = require('./color-palette-14d554dc.js');
var zIndices = require('./z-indices-4192e40e.js');
var focusVisibleSelector = require('./focus-visible-selector-7139d43f.js');
var useIsFocusVisible = require('./useIsFocusVisible-5ebbc940.js');
var ReactDOM = require('react-dom');
var iconLibrary_systemIcons_standardIcons_chevronDown = require('./icon-library/system-icons/standard-icons/chevron-down/index.js');
var iconLibrary_systemIcons_standardIcons_chevronUp = require('./icon-library/system-icons/standard-icons/chevron-up/index.js');
var NumberFormat = require('react-number-format');
var Paper = require('./Paper-219dcd73.js');
var IconButton = require('./IconButton-870d358b.js');
var hooks_useCombinedClassName = require('./hooks/use-combined-class-name/index.js');
var iconLibrary_notificationIcons_errorDark = require('./icon-library/notification-icons/error-dark/index.js');
var Typography = require('./Typography-2a62e08c.js');
var iconLibrary_systemIcons_standardIcons_search = require('./icon-library/system-icons/standard-icons/search/index.js');
require('./social-button-8479390a.js');
var monosten = require('./monosten-d688040f.js');
var debounce = require('./debounce-41e267c7.js');
var deprecatedPropType = require('./deprecatedPropType-e4925b44.js');
var useTheme = require('./useTheme-663f5947.js');
var require$$0 = require('react-is');
var Modal = require('./Modal-602b2681.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var ReactDOM__namespace = /*#__PURE__*/_interopNamespace(ReactDOM);
var NumberFormat__default = /*#__PURE__*/_interopDefaultLegacy(NumberFormat);

var styles$s = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/React__namespace.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    className: withStyles.clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize.capitalize(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat(capitalize.capitalize(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/React__namespace.createElement("title", null, titleAccess) : null);
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: defaultTheme.PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: withStyles.chainPropTypes(defaultTheme.PropTypes.oneOf(['default', 'inherit', 'large', 'medium', 'small']), function (props) {
    var fontSize = props.fontSize;

    if (fontSize === 'default') {
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    }

    return null;
  }),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: defaultTheme.PropTypes.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: defaultTheme.PropTypes.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: defaultTheme.PropTypes.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: defaultTheme.PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = withStyles.withStyles(styles$s, {
  name: 'MuiSvgIcon'
})(SvgIcon);

/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/React__default['default'].createElement(SvgIcon$1, defaultTheme._extends({
      ref: ref
    }, props), path);
  };

  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(Component));
}

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/React__namespace.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

/**
 * @ignore - internal component.
 */

var FormControlContext = React__namespace.createContext();

if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}

function useFormControl$1() {
  return React__namespace.useContext(FormControlContext);
}

function useFormControl() {
  return React__namespace.useContext(FormControlContext);
}

var styles$r = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase = /*#__PURE__*/React__namespace.forwardRef(function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = defaultTheme._objectWithoutProperties(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = tooltip.useControlled({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  }),
      _useControlled2 = defaultTheme._slicedToArray(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = useFormControl();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v5: remove the second argument.
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return /*#__PURE__*/React__namespace.createElement(IconButton.IconButton, defaultTheme._extends({
    component: "span",
    className: withStyles.clsx(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), /*#__PURE__*/React__namespace.createElement("input", defaultTheme._extends({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

process.env.NODE_ENV !== "production" ? SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: defaultTheme.PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: defaultTheme.PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * @ignore
   */
  defaultChecked: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: defaultTheme.PropTypes.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: defaultTheme.PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: defaultTheme.PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: tooltip.refType,

  /*
   * @ignore
   */
  name: defaultTheme.PropTypes.string,

  /**
   * @ignore
   */
  onBlur: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onFocus: defaultTheme.PropTypes.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * The input component prop `type`.
   */
  type: defaultTheme.PropTypes.string.isRequired,

  /**
   * The value of the component.
   */
  value: defaultTheme.PropTypes.any
} : void 0;
var SwitchBase$1 = withStyles.withStyles(styles$r, {
  name: 'PrivateSwitchBase'
})(SwitchBase);

/**
 * @ignore - internal component.
 */

var CheckBoxOutlineBlankIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

/**
 * @ignore - internal component.
 */

var CheckBoxIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

/**
 * @ignore - internal component.
 */

var IndeterminateCheckBoxIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

var styles$q = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
    indeterminate: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: defaultTheme.alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: defaultTheme.alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon$1 = /*#__PURE__*/React__namespace.createElement(CheckBoxIcon, null);
var defaultIcon$1 = /*#__PURE__*/React__namespace.createElement(CheckBoxOutlineBlankIcon, null);
var defaultIndeterminateIcon = /*#__PURE__*/React__namespace.createElement(IndeterminateCheckBoxIcon, null);
var Checkbox = /*#__PURE__*/React__namespace.forwardRef(function Checkbox(props, ref) {
  var _props$checkedIcon = props.checkedIcon,
      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon$1 : _props$checkedIcon,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$icon = props.icon,
      iconProp = _props$icon === void 0 ? defaultIcon$1 : _props$icon,
      _props$indeterminate = props.indeterminate,
      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
      _props$indeterminateI = props.indeterminateIcon,
      indeterminateIconProp = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
      inputProps = props.inputProps,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = defaultTheme._objectWithoutProperties(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);

  var icon = indeterminate ? indeterminateIconProp : iconProp;
  var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  return /*#__PURE__*/React__namespace.createElement(SwitchBase$1, defaultTheme._extends({
    type: "checkbox",
    classes: {
      root: withStyles.clsx(classes.root, classes["color".concat(capitalize.capitalize(color))], indeterminate && classes.indeterminate),
      checked: classes.checked,
      disabled: classes.disabled
    },
    color: color,
    inputProps: defaultTheme._extends({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/React__namespace.cloneElement(icon, {
      fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
    }),
    checkedIcon: /*#__PURE__*/React__namespace.cloneElement(indeterminateIcon, {
      fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
    }),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Checkbox.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: defaultTheme.PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * If `true`, the checkbox will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: defaultTheme.PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: defaultTheme.PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: defaultTheme.PropTypes.string,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: defaultTheme.PropTypes.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: defaultTheme.PropTypes.node,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: defaultTheme.PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: tooltip.refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * The size of the checkbox.
   * `small` is equivalent to the dense checkbox styling.
   */
  size: defaultTheme.PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: defaultTheme.PropTypes.any
} : void 0;
var MuiCheckbox = withStyles.withStyles(styles$q, {
  name: 'MuiCheckbox'
})(Checkbox);

var CheckboxIconUnchecked = function CheckboxIconUnchecked() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "ouCheckboxUnchecked",
    width: "24",
    height: "24",
    fill: "none"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "1",
    y: "1",
    width: "22",
    height: "22",
    rx: "3",
    strokeWidth: "2"
  }));
};
var CheckboxIconChecked = function CheckboxIconChecked() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "ouCheckboxChecked",
    width: "24",
    height: "24",
    fill: "none"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    width: "24",
    height: "24",
    rx: "4"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M18.7724 7.21181C19.0696 7.5003 19.0767 7.97513 18.7882 8.27236L10.5382 16.7724C10.3983 16.9165 10.2064 16.9985 10.0056 17C9.80475 17.0015 9.61169 16.9224 9.46967 16.7803L5.21967 12.5303C4.92678 12.2374 4.92678 11.7626 5.21967 11.4697C5.51256 11.1768 5.98744 11.1768 6.28033 11.4697L9.99203 15.1814L17.7118 7.22764C18.0003 6.93041 18.4751 6.92333 18.7724 7.21181Z"
  }));
};

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}

var styles$p = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */

var FormControl = /*#__PURE__*/React__namespace.forwardRef(function FormControl(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      visuallyFocused = props.focused,
      _props$hiddenLabel = props.hiddenLabel,
      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? 'none' : _props$margin,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      size = props.size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);

  var _React$useState = React__namespace.useState(function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialAdornedStart = false;

    if (children) {
      React__namespace.Children.forEach(children, function (child) {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }

        var input = isMuiElement(child, ['Select']) ? child.props.input : child;

        if (input && isAdornedStart(input.props)) {
          initialAdornedStart = true;
        }
      });
    }

    return initialAdornedStart;
  }),
      adornedStart = _React$useState[0],
      setAdornedStart = _React$useState[1];

  var _React$useState2 = React__namespace.useState(function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialFilled = false;

    if (children) {
      React__namespace.Children.forEach(children, function (child) {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }

        if (isFilled(child.props, true)) {
          initialFilled = true;
        }
      });
    }

    return initialFilled;
  }),
      filled = _React$useState2[0],
      setFilled = _React$useState2[1];

  var _React$useState3 = React__namespace.useState(false),
      _focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;

  if (disabled && focused) {
    setFocused(false);
  }

  var registerEffect;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var registeredInput = React__namespace.useRef(false);

    registerEffect = function registerEffect() {
      if (registeredInput.current) {
        console.error(['Material-UI: There are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
      }

      registeredInput.current = true;
      return function () {
        registeredInput.current = false;
      };
    };
  }

  var onFilled = React__namespace.useCallback(function () {
    setFilled(true);
  }, []);
  var onEmpty = React__namespace.useCallback(function () {
    setFilled(false);
  }, []);
  var childContext = {
    adornedStart: adornedStart,
    setAdornedStart: setAdornedStart,
    color: color,
    disabled: disabled,
    error: error,
    filled: filled,
    focused: focused,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    margin: (size === 'small' ? 'dense' : undefined) || margin,
    onBlur: function onBlur() {
      setFocused(false);
    },
    onEmpty: onEmpty,
    onFilled: onFilled,
    onFocus: function onFocus() {
      setFocused(true);
    },
    registerEffect: registerEffect,
    required: required,
    variant: variant
  };
  return /*#__PURE__*/React__namespace.createElement(FormControlContext.Provider, {
    value: childContext
  }, /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    className: withStyles.clsx(classes.root, className, margin !== 'none' && classes["margin".concat(capitalize.capitalize(margin))], fullWidth && classes.fullWidth),
    ref: ref
  }, other), children));
});
process.env.NODE_ENV !== "production" ? FormControl.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The contents of the form control.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the component will be displayed in focused state.
   */
  focused: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the label will be hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   */
  hiddenLabel: defaultTheme.PropTypes.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: defaultTheme.PropTypes.oneOf(['dense', 'none', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * The size of the text field.
   */
  size: defaultTheme.PropTypes.oneOf(['medium', 'small']),

  /**
   * The variant to use.
   */
  variant: defaultTheme.PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var FormControl$1 = withStyles.withStyles(styles$p, {
  name: 'MuiFormControl'
})(FormControl);

var styles$o = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },

    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: 'column-reverse',
      marginLeft: 16
    },

    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: 'column',
      marginLeft: 16
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

var FormControlLabel = /*#__PURE__*/React__namespace.forwardRef(function FormControlLabel(props, ref) {
  props.checked;
      var classes = props.classes,
      className = props.className,
      control = props.control,
      disabledProp = props.disabled;
      props.inputRef;
      var label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement;
      props.name;
      props.onChange;
      props.value;
      var other = defaultTheme._objectWithoutProperties(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);

  var muiFormControl = useFormControl();
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return /*#__PURE__*/React__namespace.createElement("label", defaultTheme._extends({
    className: withStyles.clsx(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat(capitalize.capitalize(labelPlacement))], disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/React__namespace.cloneElement(control, controlProps), /*#__PURE__*/React__namespace.createElement(Typography.Typography, {
    component: "span",
    className: withStyles.clsx(classes.label, disabled && classes.disabled)
  }, label));
});
process.env.NODE_ENV !== "production" ? FormControlLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component appears selected.
   */
  checked: defaultTheme.PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: defaultTheme.PropTypes.element.isRequired,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: tooltip.refType,

  /**
   * The text to be used in an enclosing label element.
   */
  label: defaultTheme.PropTypes.node,

  /**
   * The position of the label.
   */
  labelPlacement: defaultTheme.PropTypes.oneOf(['bottom', 'end', 'start', 'top']),

  /**
   * @ignore
   */
  name: defaultTheme.PropTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * The value of the component.
   */
  value: defaultTheme.PropTypes.any
} : void 0;
var FormControlLabel$1 = withStyles.withStyles(styles$o, {
  name: 'MuiFormControlLabel'
})(FormControlLabel);

/**
 * Mixin for styles common to checkboxes and radio buttons
 */
var commonIconInputsMixin = styled.css(["border-radius:", "px;margin:0;padding:", "px;width:", ";min-width:160px;.MuiTypography-root{font-size:unset;}.MuiIconButton-root{padding:0;align-self:start;}.MuiFormControlLabel-label{", ";padding-left:", "px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.shape.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(2.5);
}, function (_ref3) {
  var width = _ref3.width;
  return width;
}, element.ownUpBodyMixin, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing(2);
});

var _templateObject$8;
var StyledCheckboxLabel = styled__default['default'](FormControlLabel$1)(_templateObject$8 || (_templateObject$8 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  background-color: ", ";\n  max-width: none;\n\n  .Mui-disabled {\n    color: ", ";\n  }\n\n  .ouCheckboxChecked {\n    rect {\n      fill: ", ";\n    }\n    path {\n      fill: ", ";\n    }\n  }\n\n  .ouCheckboxUnchecked rect {\n    stroke: ", ";\n  }\n\n  ", " {\n    &:hover:not(.Mui-disabled) {\n      .ouCheckboxUnchecked rect {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", "\n"])), commonIconInputsMixin, function (_ref) {
  var theme = _ref.theme;
  return theme.checkboxColors.checkboxFontColorLabel;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.checkboxColors.checkboxColorBackground;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.checkboxColors.checkboxFontColorLabel;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.checkboxColors.checkboxColorSelected;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.checkboxColors.checkboxColorControl;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.checkboxColors.checkboxColorBorder;
}, iconButtons.stickyHoverMixin, function (_ref7) {
  var theme = _ref7.theme;
  return theme.checkboxColors.checkboxColorHover;
}, function (_ref8) {
  var $focusVisible = _ref8.$focusVisible,
    theme = _ref8.theme;
  return $focusVisible ? styled.css(["&:not(:hover){.ouCheckboxUnchecked rect{fill:", ";}}& .Mui-disabled .ouCheckboxUnchecked rect{fill:none;}&", ""], theme.checkboxColors.checkboxColorFocus, elementOutline.createElementOutlineMixin({
    width: "".concat(theme.spacing(0.25), "px"),
    color: theme.checkboxColors.checkboxColorBorder,
    radius: "".concat(theme.shape.borderRadius, "px")
  })) : undefined;
});

var _excluded$8 = ["children", "width", "disabledReason", "labelRef"],
  _excluded2$1 = ["onChange", "checked"];

/**
 * Renders a checkbox.
 *
 * @remarks
 * This component leverages material-ui's Checkbox component {@link https://mui.com/components/checkboxes/}
 *
 * @param id - (optional) The element id
 * @param disabled - (optional) Boolean indicating whether the input should be in an inactive state
 * @param disabledReason - (optional) Message to display in a tooltip when the input is inactive
 * @param labelRef - (optional) ref to access <FormControlLabel>
 * @param width - (optional) CSS width value for the component
 * @returns A styled checkbox component
 *
 */
var OwnUpCheckbox = function OwnUpCheckbox(_ref) {
  var children = _ref.children,
    width = _ref.width,
    disabledReason = _ref.disabledReason,
    labelRef = _ref.labelRef,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$8);
  var _React$useState = React__default['default'].useState(false),
    _React$useState2 = _rollupPluginBabelHelpers._slicedToArray(_React$useState, 2),
    focusVisible = _React$useState2[0],
    setFocusVisible = _React$useState2[1];
  var inactiveProps = React.useMemo(function () {
    return {
      onChange: undefined,
      // Prevent field from being toggled
      disabled: false,
      checked: props.checked || false,
      // Lock the state as-is
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'aria-disabled': true,
      className: 'Mui-disabled'
    };
  }, [props.checked]);
  inactiveProps.onChange;
    inactiveProps.checked;
    var restInactiveProps = _rollupPluginBabelHelpers._objectWithoutProperties(inactiveProps, _excluded2$1);
  var checkboxComponent = React.useMemo(function () {
    return /*#__PURE__*/React__default['default'].createElement(StyledCheckboxLabel, _rollupPluginBabelHelpers._extends({
      width: width,
      $focusVisible: focusVisible,
      control: /*#__PURE__*/React__default['default'].createElement(MuiCheckbox, _rollupPluginBabelHelpers._extends({}, props, {
        icon: /*#__PURE__*/React__default['default'].createElement(CheckboxIconUnchecked, null),
        checkedIcon: /*#__PURE__*/React__default['default'].createElement(CheckboxIconChecked, null),
        onFocusVisible: function onFocusVisible() {
          return setFocusVisible(true);
        },
        onBlur: function onBlur() {
          return setFocusVisible(false);
        }
      }, props.disabled ? inactiveProps : {})),
      ref: labelRef,
      label: children
    }, props.disabled ? restInactiveProps : {}));
  }, [width, focusVisible, setFocusVisible, props, inactiveProps, restInactiveProps, labelRef, children]);
  return props.disabled && disabledReason ? /*#__PURE__*/React__default['default'].createElement(tooltip.OwnUpTooltip, {
    description: disabledReason
  }, checkboxComponent) : checkboxComponent;
};

var styles$n = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },

  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    '&$positionStart:not($hiddenLabel)': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },

  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: 'none'
  },

  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
  hiddenLabel: {},

  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
  marginDense: {}
};
var InputAdornment = /*#__PURE__*/React__namespace.forwardRef(function InputAdornment(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disablePointer = props.disablePointerEvents,
      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      position = props.position,
      variantProp = props.variant,
      other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);

  var muiFormControl = useFormControl$1() || {};
  var variant = variantProp;

  if (variantProp && muiFormControl.variant) {
    if (process.env.NODE_ENV !== 'production') {
      if (variantProp === muiFormControl.variant) {
        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  return /*#__PURE__*/React__namespace.createElement(FormControlContext.Provider, {
    value: null
  }, /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    className: withStyles.clsx(classes.root, className, position === 'end' ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, muiFormControl.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/React__namespace.createElement(Typography.Typography, {
    color: "textSecondary"
  }, children) : children));
});
process.env.NODE_ENV !== "production" ? InputAdornment.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: defaultTheme.PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: defaultTheme.PropTypes.bool,

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  muiFormControl: defaultTheme.PropTypes.object,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: defaultTheme.PropTypes.oneOf(['start', 'end']).isRequired,

  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: defaultTheme.PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
var InputAdornment$1 = withStyles.withStyles(styles$n, {
  name: 'MuiInputAdornment'
})(InputAdornment);

function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}

var styles$m = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: defaultTheme._extends({
      color: theme.palette.text.secondary
    }, theme.typography.caption, {
      textAlign: 'left',
      marginTop: 3,
      margin: 0,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      marginLeft: 14,
      marginRight: 14
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
};
var FormHelperText = /*#__PURE__*/React__namespace.forwardRef(function FormHelperText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'p' : _props$component;
      props.disabled;
      props.error;
      props.filled;
      props.focused;
      props.margin;
      props.required;
      props.variant;
      var other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);

  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    className: withStyles.clsx(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), children === ' ' ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  React__namespace.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : children);
});
process.env.NODE_ENV !== "production" ? FormHelperText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: defaultTheme.PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: defaultTheme.PropTypes.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: defaultTheme.PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var FormHelperText$1 = withStyles.withStyles(styles$m, {
  name: 'MuiFormHelperText'
})(FormHelperText);

var styles$l = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: defaultTheme._extends({
      color: theme.palette.text.secondary
    }, theme.typography.body1, {
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused': {
        color: theme.palette.secondary.main
      }
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Styles applied to the asterisk element. */
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};
var FormLabel = /*#__PURE__*/React__namespace.forwardRef(function FormLabel(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className;
      props.color;
      var _props$component = props.component,
      Component = _props$component === void 0 ? 'label' : _props$component;
      props.disabled;
      props.error;
      props.filled;
      props.focused;
      props.required;
      var other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);

  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  return /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    className: withStyles.clsx(classes.root, classes["color".concat(capitalize.capitalize(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
    ref: ref
  }, other), children, fcs.required && /*#__PURE__*/React__namespace.createElement("span", {
    "aria-hidden": true,
    className: withStyles.clsx(classes.asterisk, fcs.error && classes.error)
  }, "\u2009", '*'));
});
process.env.NODE_ENV !== "production" ? FormLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: defaultTheme.PropTypes.bool
} : void 0;
var FormLabel$1 = withStyles.withStyles(styles$l, {
  name: 'MuiFormLabel'
})(FormLabel);

var styles$k = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      transformOrigin: 'top left'
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 17px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 12px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};
var InputLabel = /*#__PURE__*/React__namespace.forwardRef(function InputLabel(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableAnimati = props.disableAnimation,
      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati;
      props.margin;
      var shrinkProp = props.shrink;
      props.variant;
      var other = defaultTheme._objectWithoutProperties(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);

  var muiFormControl = useFormControl();
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['margin', 'variant']
  });
  return /*#__PURE__*/React__namespace.createElement(FormLabel$1, defaultTheme._extends({
    "data-shrink": shrink,
    className: withStyles.clsx(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
      'filled': classes.filled,
      'outlined': classes.outlined
    }[fcs.variant]),
    classes: {
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required,
      asterisk: classes.asterisk
    },
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? InputLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The contents of the `InputLabel`.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['primary', 'secondary']),

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: defaultTheme.PropTypes.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: defaultTheme.PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: defaultTheme.PropTypes.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: defaultTheme.PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: defaultTheme.PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var InputLabel$1 = withStyles.withStyles(styles$k, {
  name: 'MuiInputLabel'
})(InputLabel);

var outerLabelFontSize = '1.25rem';
var innerLabelFontSizeUnselected = '1.5rem';
var innerLabelFontSizeSelected = '1.125rem';
var inputFontSpacingVertical = "".concat(element$1.ownUpWhiteTheme.spacing(1.5), "px");
var inputFontSpacingHorizontal = "".concat(element$1.ownUpWhiteTheme.spacing(2.5), "px");
var inputFontSizeResponse = '1.5rem';
var inputFontSizePlaceholder = '1.5rem';
var inputPadding = inputFontSpacingHorizontal;
var inputBackgroundSpacing = inputPadding;
var inputFontSpacingTopEntry = "".concat(element$1.ownUpWhiteTheme.spacing(1.25), "px");
var inputFontSpacingBottomEntry = "".concat(element$1.ownUpWhiteTheme.spacing(1.5), "px");
var inputBackgroundRadius$1 = '4px';
var inputBackgroundRadiusTop = inputBackgroundRadius$1;
var inputBackgroundRadiusBottom = inputBackgroundRadius$1;
var inputScrollbarWidth = '4px';
var inputScrollbarSpacing = "".concat(element$1.ownUpWhiteTheme.spacing(1), "px");
var inputIconSizeDropdown = '1.25rem';
var inputIconSizeError = '1.5rem';
var inputIconSpacing = "".concat(element$1.ownUpWhiteTheme.spacing(2), "px");

/**
 * Mixin to generate right-padding and text truncation properties
 *   for text in an input.
 *
 * Necessitates that the field receive a "Mui-error" class when in
 *   an error state.
 */
var inputRightPaddingMixin = styled.css(["max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;&:not(.MuiInputBase-inputAdornedEnd){padding-right:calc( ", " + ", " + ", " );}&.MuiInputBase-inputAdornedEnd{padding-right:calc( ", " + ", " + (", " * 2) + ", " );}"], inputFontSpacingHorizontal, inputIconSizeDropdown, inputIconSpacing, inputFontSpacingHorizontal, inputIconSizeDropdown, inputIconSpacing, inputIconSizeError);
var outerLabelStyle = styled.css(["", " line-height:", ";color:", ";"], element.ownUpSmallBodyMediumMixin, outerLabelFontSize, function (_ref) {
  var theme = _ref.theme;
  return theme.inputColors.inputFontColorLabelAbove;
});
var innerLabelStyle = styled.css(["transform:unset;color:", ";pointer-events:none;&:not(.MuiInputLabel-shrink){", " margin:", ";line-height:", ";}&.MuiInputLabel-shrink{", " margin:", " ", " 0 ", ";line-height:", ";}", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.inputColors.inputFontColorLabel;
}, element.ownUpBodyMixin, inputPadding, innerLabelFontSizeUnselected, element.ownUpDetailMixin, inputFontSpacingTopEntry, inputFontSpacingHorizontal, inputFontSpacingHorizontal, innerLabelFontSizeSelected, inputRightPaddingMixin);
var inputUnderlineMixin = styled.css(["border-bottom:none;height:1px;margin:auto;width:100%;border-radius:25px;"]);
var ownUpFormControlStyle = styled.css(["&.MuiFormControl-root{width:100%;}& .MuiFormLabel-root{transform:unset;", ";z-index:", ";}& .MuiInputBase-root{margin-top:", ";margin-bottom:", ";}.MuiInput-underline:not(.Mui-error):before,.MuiInput-underline:not(.Mui-error):after{", " background-color:", ";}.MuiInput-underline.Mui-error:before,.MuiInput-underline.Mui-error:after{", " background-color:", ";}.MuiInput-underline:not(.Mui-error):not(.Mui-disabled):hover:before,.MuiInput-underline:not(.Mui-error):not(.Mui-disabled):hover:after,.MuiInput-underline:not(.Mui-error).Mui-focused:before,.MuiInput-underline:not(.Mui-error).Mui-focused:after{", " height:2px;background-color:", ";}.MuiInput-underline.Mui-error:not(.Mui-disabled):hover:before,.MuiInput-underline.Mui-error:not(.Mui-disabled):hover:after,.MuiInput-underline.Mui-error.Mui-focused:before,.MuiInput-underline.Mui-error.Mui-focused:after{", " height:2px;background-color:", ";}& .MuiFormHelperText-root{", " color:", ";margin:0 ", " ", " ", ";&.Mui-error{color:", ";}}& .MuiInputAdornment-positionEnd{position:absolute;right:calc(", " + ", " + ", ");pointer-events:none;&,& svg{margin:0;width:", ";height:", ";& path{fill:", ";}}}"], function (_ref3) {
  var labelPosition = _ref3.labelPosition;
  return labelPosition === 'outer' ? outerLabelStyle : innerLabelStyle;
}, zIndices.Z_INDICES.FORM_LABELS, function (_ref4) {
  var labelPosition = _ref4.labelPosition;
  return labelPosition === 'outer' ? "calc(".concat(inputFontSpacingVertical, " + ").concat(outerLabelFontSize, ")") : 0;
}, inputFontSpacingVertical, inputUnderlineMixin, function (_ref5) {
  var theme = _ref5.theme;
  return theme.inputColors.inputUnderline;
}, inputUnderlineMixin, function (_ref6) {
  var theme = _ref6.theme;
  return theme.inputColors.inputBorderColorError;
}, inputUnderlineMixin, function (props) {
  return props.theme.inputColors.inputUnderline;
}, inputUnderlineMixin, function (_ref7) {
  var theme = _ref7.theme;
  return theme.inputColors.inputBorderColorError;
}, element.ownUpDetailMixin, function (_ref8) {
  var theme = _ref8.theme;
  return theme.inputColors.inputFontColorHelp;
}, inputFontSpacingHorizontal, inputFontSpacingVertical, inputFontSpacingHorizontal, function (_ref9) {
  var theme = _ref9.theme;
  return theme.inputColors.inputFontColorError;
}, inputIconSizeDropdown, inputFontSpacingHorizontal, inputIconSpacing, inputIconSizeError, inputIconSizeError, function (_ref10) {
  var theme = _ref10.theme;
  return theme.inputColors.inputFontColorError;
});

var _templateObject$7;
var _excluded$7 = ["children", "disabled", "disabledReason", "$inputId", "label", "labelPosition", "helperText", "error", "inputLabelRef", "formHelperTextRef", "errorTextRef", "shrink"];

/**
 * Wrapper around MUI's {@see FormControl} element which helps
 *   structure pages with form elements. Contains common styling
 *   for certain label types.
 *
 * @param {@see OwnUpFormControlProps}
 */
var BaseFormControl = function BaseFormControl(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    disabledReason = _ref.disabledReason,
    $inputId = _ref.$inputId,
    label = _ref.label,
    labelPosition = _ref.labelPosition,
    helperText = _ref.helperText,
    error = _ref.error,
    inputLabelRef = _ref.inputLabelRef,
    formHelperTextRef = _ref.formHelperTextRef,
    errorTextRef = _ref.errorTextRef,
    shrink = _ref.shrink,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$7);
  // Label will be rendered either embedded in the form element
  //   or above it, depending on the "labelPosition" input
  var labelElement = React.useMemo(function () {
    return label ? /*#__PURE__*/React__default['default'].createElement(InputLabel$1, {
      error: !!error,
      htmlFor: $inputId
      // Match the input's enabled/disabled state only if it's an inner
      //   label.
      ,
      disabled: labelPosition === 'inner' ? disabled : false
      // Always set the label to shrink when it's an outer label
      ,
      shrink: labelPosition === 'outer' ? true : shrink,
      ref: inputLabelRef
    }, label) : undefined;
  }, [disabled, error, $inputId, inputLabelRef, label, labelPosition, shrink]);

  // Below the element the helper text will be rendered (if
  //   provided). If an error message is present it will be
  //   shown instead.
  var helperTextElement = React.useMemo(function () {
    return error || helperText ? /*#__PURE__*/React__default['default'].createElement(FormHelperText$1, {
      error: !!error,
      ref: error ? errorTextRef : formHelperTextRef
    }, error || helperText) : undefined;
  }, [helperText, error, errorTextRef, formHelperTextRef]);

  // If the element is disabled and a disabledReason is provided,
  //   a tooltip displaying the disabledReason will be shown.
  var tooltipWrappedComponent = React.useMemo(function () {
    return disabled && disabledReason ? /*#__PURE__*/React__default['default'].createElement(tooltip.OwnUpTooltip, {
      description: disabledReason
    }, children) : children;
  }, [children, disabled, disabledReason]);

  // Memoize the full component.
  var fullComponent = React.useMemo(function () {
    return /*#__PURE__*/React__default['default'].createElement(FormControl$1, _rollupPluginBabelHelpers._extends({
      error: !!error
    }, props), labelElement, tooltipWrappedComponent, helperTextElement);
  }, [tooltipWrappedComponent, error, helperTextElement, labelElement, props]);
  return fullComponent;
};

/**
 * Wrapper around MUI's {@see FormControl} element which helps
 *   structure pages with form elements. Contains common styling
 *   for certain label types.
 *
 * @param {@see OwnUpFormControlProps}
 */
var OwnUpFormControl = styled__default['default'](BaseFormControl)(_templateObject$7 || (_templateObject$7 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n"])), ownUpFormControlStyle);

/**
 * @ignore - internal component.
 */

var ListContext = React__namespace.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}

var styles$j = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect$3 = typeof window === 'undefined' ? React__namespace.useEffect : React__namespace.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = /*#__PURE__*/React__namespace.forwardRef(function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = defaultTheme._objectWithoutProperties(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = defaultTheme._objectWithoutProperties(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = React__namespace.useContext(ListContext);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = React__namespace.useRef(null);
  useEnhancedEffect$3(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('Material-UI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var children = React__namespace.Children.toArray(childrenProp);
  var hasSecondaryAction = children.length && isMuiElement(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = React__namespace.useCallback(function (instance) {
    // #StrictMode ready
    listItemRef.current = ReactDOM__namespace.findDOMNode(instance);
  }, []);
  var handleRef = useIsFocusVisible.useForkRef(handleOwnRef, ref);

  var componentProps = defaultTheme._extends({
    className: withStyles.clsx(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = withStyles.clsx(classes.focusVisible, focusVisibleClassName);
    Component = iconButtons.ButtonBase;
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/React__namespace.createElement(ListContext.Provider, {
      value: childContext
    }, /*#__PURE__*/React__namespace.createElement(ContainerComponent, defaultTheme._extends({
      className: withStyles.clsx(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/React__namespace.createElement(Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/React__namespace.createElement(ListContext.Provider, {
    value: childContext
  }, /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    ref: handleRef
  }, componentProps), children));
});
process.env.NODE_ENV !== "production" ? ListItem.propTypes = {
  /**
   * Defines the `align-items` style property.
   */
  alignItems: defaultTheme.PropTypes.oneOf(['flex-start', 'center']),

  /**
   * If `true`, the list item will be focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   */
  autoFocus: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   */
  button: defaultTheme.PropTypes.bool,

  /**
   * The content of the component. If a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: withStyles.chainPropTypes(defaultTheme.PropTypes.node, function (props) {
    var children = React__namespace.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)

    var secondaryActionIndex = -1;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];

      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('Material-UI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   */
  ContainerComponent: defaultTheme.PropTypes.elementType,

  /**
   * Props applied to the container component if used.
   */
  ContainerProps: defaultTheme.PropTypes.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: defaultTheme.PropTypes.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: defaultTheme.PropTypes.string,

  /**
   * Use to apply selected styling.
   */
  selected: defaultTheme.PropTypes.bool
} : void 0;
var ListItem$1 = withStyles.withStyles(styles$j, {
  name: 'MuiListItem'
})(ListItem);

var styles$i = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: defaultTheme._extends({}, theme.typography.body1, defaultTheme._defineProperty({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: defaultTheme._extends({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/React__namespace.forwardRef(function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = defaultTheme._objectWithoutProperties(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/React__namespace.createElement(ListItem$1, defaultTheme._extends({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: defaultTheme._extends({
      dense: classes.dense
    }, ListItemClasses),
    className: withStyles.clsx(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? MenuItem.propTypes = {
  /**
   * Menu item contents.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: defaultTheme.PropTypes.bool,

  /**
   * `classes` prop applied to the [`ListItem`](/api/list-item/) element.
   */
  ListItemClasses: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  role: defaultTheme.PropTypes.string,

  /**
   * @ignore
   */
  selected: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: defaultTheme.PropTypes.number
} : void 0;
var MenuItem$1 = withStyles.withStyles(styles$i, {
  name: 'MuiMenuItem'
})(MenuItem);

function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles$h = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Popover = /*#__PURE__*/React__namespace.forwardRef(function Popover(props, ref) {
  var action = props.action,
      anchorEl = props.anchorEl,
      _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$anchorOrigin,
      anchorPosition = props.anchorPosition,
      _props$anchorReferenc = props.anchorReference,
      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
      children = props.children,
      classes = props.classes,
      className = props.className,
      containerProp = props.container,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
      getContentAnchorEl = props.getContentAnchorEl,
      _props$marginThreshol = props.marginThreshold,
      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$transformOrigi = props.transformOrigin,
      transformOrigin = _props$transformOrigi === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$transformOrigi,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? tooltip.Grow : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps,
      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
      other = defaultTheme._objectWithoutProperties(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var paperRef = React__namespace.useRef(); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  var getAnchorOffset = React__namespace.useCallback(function (contentAnchorOffset) {
    if (anchorReference === 'anchorPosition') {
      if (process.env.NODE_ENV !== 'production') {
        if (!anchorPosition) {
          console.error('Material-UI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }

      return anchorPosition;
    }

    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : Modal.ownerDocument(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();

    if (process.env.NODE_ENV !== 'production') {
      var box = anchorElement.getBoundingClientRect();

      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }

    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided

  var getContentAnchorOffset = React__namespace.useCallback(function (element) {
    var contentAnchorOffset = 0;

    if (getContentAnchorEl && anchorReference === 'anchorEl') {
      var contentAnchorEl = getContentAnchorEl(element);

      if (contentAnchorEl && element.contains(contentAnchorEl)) {
        var scrollTop = getScrollParent(element, contentAnchorEl);
        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
      } // != the default value


      if (process.env.NODE_ENV !== 'production') {
        if (anchorOrigin.vertical !== 'top') {
          console.error(['Material-UI: You can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
        }
      }
    }

    return contentAnchorOffset;
  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
  // and taking the content anchor offset into account if in use

  var getTransformOrigin = React__namespace.useCallback(function (elemRect) {
    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = React__namespace.useCallback(function (element) {
    // Check if the parent has requested anchoring on an inner content node
    var contentAnchorOffset = getContentAnchorOffset(element);
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of of the anchoring element


    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning

    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    var containerWindow = Modal.ownerWindow(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;

      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['Material-UI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    } // Check if the horizontal axis needs shifting


    if (left < marginThreshold) {
      var _diff2 = left - marginThreshold;

      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;

      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }

    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
  var setPositioningStyles = React__namespace.useCallback(function () {
    var element = paperRef.current;

    if (!element) {
      return;
    }

    var positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  var handleEntering = function handleEntering(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  var handlePaperRef = React__namespace.useCallback(function (instance) {
    // #StrictMode ready
    paperRef.current = ReactDOM__namespace.findDOMNode(instance);
  }, []);
  React__namespace.useEffect(function () {
    if (open) {
      setPositioningStyles();
    }
  });
  React__namespace.useImperativeHandle(action, function () {
    return open ? {
      updatePosition: function updatePosition() {
        setPositioningStyles();
      }
    } : null;
  }, [open, setPositioningStyles]);
  React__namespace.useEffect(function () {
    if (!open) {
      return undefined;
    }

    var handleResize = debounce.debounce(function () {
      setPositioningStyles();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [open, setPositioningStyles]);
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  var container = containerProp || (anchorEl ? Modal.ownerDocument(getAnchorEl(anchorEl)).body : undefined);
  return /*#__PURE__*/React__namespace.createElement(Modal.Modal, defaultTheme._extends({
    container: container,
    open: open,
    ref: ref,
    BackdropProps: {
      invisible: true
    },
    className: withStyles.clsx(classes.root, className)
  }, other), /*#__PURE__*/React__namespace.createElement(TransitionComponent, defaultTheme._extends({
    appear: true,
    in: open,
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited,
    onExiting: onExiting,
    timeout: transitionDuration
  }, TransitionProps, {
    onEntering: tooltip.createChainedFunction(handleEntering, TransitionProps.onEntering)
  }), /*#__PURE__*/React__namespace.createElement(Paper.Paper, defaultTheme._extends({
    elevation: elevation,
    ref: handlePaperRef
  }, PaperProps, {
    className: withStyles.clsx(classes.paper, PaperProps.className)
  }), children)));
});
process.env.NODE_ENV !== "production" ? Popover.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: tooltip.refType,

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the popover.
   */
  anchorEl: withStyles.chainPropTypes(defaultTheme.PropTypes.oneOfType([tooltip.HTMLElementType, defaultTheme.PropTypes.func]), function (props) {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
      }
    }

    return null;
  }),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: defaultTheme.PropTypes.shape({
    horizontal: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.oneOf(['center', 'left', 'right']), defaultTheme.PropTypes.number]).isRequired,
    vertical: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.oneOf(['bottom', 'center', 'top']), defaultTheme.PropTypes.number]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: defaultTheme.PropTypes.shape({
    left: defaultTheme.PropTypes.number.isRequired,
    top: defaultTheme.PropTypes.number.isRequired
  }),

  /**
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: defaultTheme.PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([tooltip.HTMLElementType, defaultTheme.PropTypes.instanceOf(React__namespace.Component), defaultTheme.PropTypes.func]),

  /**
   * The elevation of the popover.
   */
  elevation: defaultTheme.PropTypes.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` prop.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: defaultTheme.PropTypes.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: defaultTheme.PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: defaultTheme.PropTypes.func,

  /**
   * Callback fired before the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired before the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * If `true`, the popover is visible.
   */
  open: defaultTheme.PropTypes.bool.isRequired,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .shape({
    component: focusVisibleSelector.elementTypeAcceptingRef
  }),

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: defaultTheme.PropTypes.shape({
    horizontal: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.oneOf(['center', 'left', 'right']), defaultTheme.PropTypes.number]).isRequired,
    vertical: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.oneOf(['bottom', 'center', 'top']), defaultTheme.PropTypes.number]).isRequired
  }),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: defaultTheme.PropTypes.elementType,

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.oneOf(['auto']), defaultTheme.PropTypes.number, defaultTheme.PropTypes.shape({
    appear: defaultTheme.PropTypes.number,
    enter: defaultTheme.PropTypes.number,
    exit: defaultTheme.PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: defaultTheme.PropTypes.object
} : void 0;
var Popover$1 = withStyles.withStyles(styles$h, {
  name: 'MuiPopover'
})(Popover);

var styles$g = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List = /*#__PURE__*/React__namespace.forwardRef(function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = React__namespace.useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);
  return /*#__PURE__*/React__namespace.createElement(ListContext.Provider, {
    value: context
  }, /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    className: withStyles.clsx(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
process.env.NODE_ENV !== "production" ? List.propTypes = {
  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: defaultTheme.PropTypes.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: defaultTheme.PropTypes.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: defaultTheme.PropTypes.node
} : void 0;
var List$1 = withStyles.withStyles(styles$g, {
  name: 'MuiList'
})(List);

function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  var text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return;
    }
  }
}

var useEnhancedEffect$2 = typeof window === 'undefined' ? React__namespace.useEffect : React__namespace.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */

var MenuList = /*#__PURE__*/React__namespace.forwardRef(function MenuList(props, ref) {
  var actions = props.actions,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$autoFocusItem = props.autoFocusItem,
      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
      children = props.children,
      className = props.className,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      onKeyDown = props.onKeyDown,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = defaultTheme._objectWithoutProperties(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);

  var listRef = React__namespace.useRef(null);
  var textCriteriaRef = React__namespace.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect$2(function () {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  React__namespace.useImperativeHandle(actions, function () {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
        // Let's ignore that piece of logic if users are already overriding the width
        // of the menu.
        var noExplicitWidth = !listRef.current.style.width;

        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat(Modal.getScrollbarSize(), "px");
          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }

        return listRef.current;
      }
    };
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    var list = listRef.current;
    var key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    var currentFocus = Modal.ownerDocument(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleOwnRef = React__namespace.useCallback(function (instance) {
    // #StrictMode ready
    listRef.current = ReactDOM__namespace.findDOMNode(instance);
  }, []);
  var handleRef = useIsFocusVisible.useForkRef(handleOwnRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  React__namespace.Children.forEach(children, function (child, index) {
    if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (require$$0.isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = React__namespace.Children.map(children, function (child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return /*#__PURE__*/React__namespace.cloneElement(child, newChildProps);
    }

    return child;
  });
  return /*#__PURE__*/React__namespace.createElement(List$1, defaultTheme._extends({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other), items);
});
process.env.NODE_ENV !== "production" ? MenuList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   */
  autoFocus: defaultTheme.PropTypes.bool,

  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   */
  autoFocusItem: defaultTheme.PropTypes.bool,

  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the menu items will not wrap focus.
   */
  disableListWrap: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  onKeyDown: defaultTheme.PropTypes.func,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: defaultTheme.PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;

var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles$f = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  },

  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Menu = /*#__PURE__*/React__namespace.forwardRef(function Menu(props, ref) {
  var _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      _props$disableAutoFoc = props.disableAutoFocusItem,
      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$MenuListProps = props.MenuListProps,
      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
      onClose = props.onClose,
      onEnteringProp = props.onEntering,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      PopoverClasses = props.PopoverClasses,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps;
  _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;

  var onEntering = _props$TransitionProp.onEntering,
      TransitionProps = defaultTheme._objectWithoutProperties(_props$TransitionProp, ["onEntering"]),
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = defaultTheme._objectWithoutProperties(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"]);

  var theme = useTheme.useTheme();
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = React__namespace.useRef(null);
  var contentAnchorRef = React__namespace.useRef(null);

  var getContentAnchorEl = function getContentAnchorEl() {
    return contentAnchorRef.current;
  };

  var handleEntering = function handleEntering(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEnteringProp) {
      onEnteringProp(element, isAppearing);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  React__namespace.Children.map(children, function (child, index) {
    if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (require$$0.isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant !== "menu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = React__namespace.Children.map(children, function (child, index) {
    if (index === activeItemIndex) {
      return /*#__PURE__*/React__namespace.cloneElement(child, {
        ref: function ref(instance) {
          // #StrictMode ready
          contentAnchorRef.current = ReactDOM__namespace.findDOMNode(instance);
          useIsFocusVisible.setRef(child.ref, instance);
        }
      });
    }

    return child;
  });
  return /*#__PURE__*/React__namespace.createElement(Popover$1, defaultTheme._extends({
    getContentAnchorEl: getContentAnchorEl,
    classes: PopoverClasses,
    onClose: onClose,
    TransitionProps: defaultTheme._extends({
      onEntering: handleEntering
    }, TransitionProps),
    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: defaultTheme._extends({}, PaperProps, {
      classes: defaultTheme._extends({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    open: open,
    ref: ref,
    transitionDuration: transitionDuration
  }, other), /*#__PURE__*/React__namespace.createElement(MenuList, defaultTheme._extends({
    onKeyDown: handleListKeyDown,
    actions: menuListActionsRef,
    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
    autoFocusItem: autoFocusItem,
    variant: variant
  }, MenuListProps, {
    className: withStyles.clsx(classes.list, MenuListProps.className)
  }), items));
});
process.env.NODE_ENV !== "production" ? Menu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the menu.
   */
  anchorEl: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([tooltip.HTMLElementType, defaultTheme.PropTypes.func]),

  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   */
  autoFocus: defaultTheme.PropTypes.bool,

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   */
  disableAutoFocusItem: defaultTheme.PropTypes.bool,

  /**
   * Props applied to the [`MenuList`](/api/menu-list/) element.
   */
  MenuListProps: defaultTheme.PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: defaultTheme.PropTypes.func,

  /**
   * Callback fired before the Menu enters.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired before the Menu exits.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * If `true`, the menu is visible.
   */
  open: defaultTheme.PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: defaultTheme.PropTypes.object,

  /**
   * `classes` prop applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: defaultTheme.PropTypes.object,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.oneOf(['auto']), defaultTheme.PropTypes.number, defaultTheme.PropTypes.shape({
    appear: defaultTheme.PropTypes.number,
    enter: defaultTheme.PropTypes.number,
    exit: defaultTheme.PropTypes.number
  })]),

  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition) component.
   */
  TransitionProps: defaultTheme.PropTypes.object,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: defaultTheme.PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
var Menu$1 = withStyles.withStyles(styles$f, {
  name: 'MuiMenu'
})(Menu);

function areEqualValues(a, b) {
  if (defaultTheme._typeof(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}

function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */


var SelectInput = /*#__PURE__*/React__namespace.forwardRef(function SelectInput(props, ref) {
  var ariaLabel = props['aria-label'],
      autoFocus = props.autoFocus,
      autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      inputRefProp = props.inputRef,
      labelId = props.labelId,
      _props$MenuProps = props.MenuProps,
      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
      multiple = props.multiple,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onOpen = props.onOpen,
      openProp = props.open,
      readOnly = props.readOnly,
      renderValue = props.renderValue,
      _props$SelectDisplayP = props.SelectDisplayProps,
      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
      tabIndexProp = props.tabIndex;
      props.type;
      var valueProp = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = defaultTheme._objectWithoutProperties(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);

  var _useControlled = tooltip.useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  }),
      _useControlled2 = defaultTheme._slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var inputRef = React__namespace.useRef(null);

  var _React$useState = React__namespace.useState(null),
      displayNode = _React$useState[0],
      setDisplayNode = _React$useState[1];

  var _React$useRef = React__namespace.useRef(openProp != null),
      isOpenControlled = _React$useRef.current;

  var _React$useState2 = React__namespace.useState(),
      menuMinWidthState = _React$useState2[0],
      setMenuMinWidthState = _React$useState2[1];

  var _React$useState3 = React__namespace.useState(false),
      openState = _React$useState3[0],
      setOpenState = _React$useState3[1];

  var handleRef = useIsFocusVisible.useForkRef(ref, inputRefProp);
  React__namespace.useImperativeHandle(handleRef, function () {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value: value
    };
  }, [displayNode, value]);
  React__namespace.useEffect(function () {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  React__namespace.useEffect(function () {
    if (displayNode) {
      var label = Modal.ownerDocument(displayNode).getElementById(labelId);

      if (label) {
        var handler = function handler() {
          if (getSelection().isCollapsed) {
            displayNode.focus();
          }
        };

        label.addEventListener('click', handler);
        return function () {
          label.removeEventListener('click', handler);
        };
      }
    }

    return undefined;
  }, [labelId, displayNode]);

  var update = function update(open, event) {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    } // Hijack the default focus behavior.


    event.preventDefault();
    displayNode.focus();
    update(true, event);
  };

  var handleClose = function handleClose(event) {
    update(false, event);
  };

  var childrenArray = React__namespace.Children.toArray(children); // Support autofill.

  var handleChange = function handleChange(event) {
    var index = childrenArray.map(function (child) {
      return child.props.value;
    }).indexOf(event.target.value);

    if (index === -1) {
      return;
    }

    var child = childrenArray[index];
    setValue(child.props.value);

    if (onChange) {
      onChange(event, child);
    }
  };

  var handleItemClick = function handleItemClick(child) {
    return function (event) {
      if (!multiple) {
        update(false, event);
      }

      var newValue;

      if (multiple) {
        newValue = Array.isArray(value) ? value.slice() : [];
        var itemIndex = value.indexOf(child.props.value);

        if (itemIndex === -1) {
          newValue.push(child.props.value);
        } else {
          newValue.splice(itemIndex, 1);
        }
      } else {
        newValue = child.props.value;
      }

      if (child.props.onClick) {
        child.props.onClick(event);
      }

      if (value === newValue) {
        return;
      }

      setValue(newValue);

      if (onChange) {
        event.persist(); // Preact support, target is read only property on a native event.

        Object.defineProperty(event, 'target', {
          writable: true,
          value: {
            value: newValue,
            name: name
          }
        });
        onChange(event, child);
      }
    };
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!readOnly) {
      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  var open = displayNode !== null && (isOpenControlled ? openProp : openState);

  var handleBlur = function handleBlur(event) {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      event.persist(); // Preact support, target is read only property on a native event.

      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value: value,
          name: name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  var display;
  var displaySingle;
  var displayMultiple = [];
  var computeDisplay = false;
  var foundMatch = false; // No need to display any value if the field is empty.

  if (isFilled({
    value: value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  var items = childrenArray.map(function (child) {
    if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
      return null;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (require$$0.isFragment(child)) {
        console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : defaultTheme.formatMuiErrorMessage(2));
      }

      selected = value.some(function (v) {
        return areEqualValues(v, child.props.value);
      });

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    if (selected) {
      foundMatch = true;
    }

    return /*#__PURE__*/React__namespace.cloneElement(child, {
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      onKeyUp: function onKeyUp(event) {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }

        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected: selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__namespace.useEffect(function () {
      if (!foundMatch && !multiple && value !== '') {
        var values = childrenArray.map(function (child) {
          return child.props.value;
        });
        console.warn(["Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
          return x != null;
        }).map(function (x) {
          return "`".concat(x, "`");
        }).join(', ') || '""', ".")].join('\n'));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }

  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  } // Avoid performing a layout computation in the render method.


  var menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  var tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", defaultTheme._extends({
    className: withStyles.clsx(classes.root, // TODO v5: merge root and select
    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
    ref: setDisplayNode,
    tabIndex: tabIndex,
    role: "button",
    "aria-disabled": disabled ? 'true' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
    onKeyDown: handleKeyDown,
    onMouseDown: disabled || readOnly ? null : handleMouseDown,
    onBlur: handleBlur,
    onFocus: onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty(display) ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  React__namespace.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : display), /*#__PURE__*/React__namespace.createElement("input", defaultTheme._extends({
    value: Array.isArray(value) ? value.join(',') : value,
    name: name,
    ref: inputRef,
    "aria-hidden": true,
    onChange: handleChange,
    tabIndex: -1,
    className: classes.nativeInput,
    autoFocus: autoFocus
  }, other)), /*#__PURE__*/React__namespace.createElement(IconComponent, {
    className: withStyles.clsx(classes.icon, classes["icon".concat(capitalize.capitalize(variant))], open && classes.iconOpen, disabled && classes.disabled)
  }), /*#__PURE__*/React__namespace.createElement(Menu$1, defaultTheme._extends({
    id: "menu-".concat(name || ''),
    anchorEl: displayNode,
    open: open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: defaultTheme._extends({
      'aria-labelledby': labelId,
      role: 'listbox',
      disableListWrap: true
    }, MenuProps.MenuListProps),
    PaperProps: defaultTheme._extends({}, MenuProps.PaperProps, {
      style: defaultTheme._extends({
        minWidth: menuMinWidth
      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
    })
  }), items));
});
process.env.NODE_ENV !== "production" ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  'aria-label': defaultTheme.PropTypes.string,

  /**
   * @ignore
   */
  autoFocus: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: defaultTheme.PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: defaultTheme.PropTypes.any,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: defaultTheme.PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: defaultTheme.PropTypes.elementType.isRequired,

  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: tooltip.refType,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: defaultTheme.PropTypes.string,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: defaultTheme.PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: defaultTheme.PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: defaultTheme.PropTypes.string,

  /**
   * @ignore
   */
  onBlur: defaultTheme.PropTypes.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onFocus: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: defaultTheme.PropTypes.func,

  /**
   * Control `select` open state.
   */
  open: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  readOnly: defaultTheme.PropTypes.bool,

  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: defaultTheme.PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  tabIndex: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * @ignore
   */
  type: defaultTheme.PropTypes.any,

  /**
   * The input value.
   */
  value: defaultTheme.PropTypes.any,

  /**
   * The variant to use.
   */
  variant: defaultTheme.PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;

/**
 * @ignore - internal component.
 */

var ArrowDropDownIcon$1 = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

var useEnhancedEffect$1 = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
var styles$e = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
var TextareaAutosize = /*#__PURE__*/React__namespace.forwardRef(function TextareaAutosize(props, ref) {
  var onChange = props.onChange,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMinProp = props.rowsMin,
      maxRowsProp = props.maxRows,
      _props$minRows = props.minRows,
      minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows,
      style = props.style,
      value = props.value,
      other = defaultTheme._objectWithoutProperties(props, ["onChange", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "style", "value"]);

  var maxRows = maxRowsProp || rowsMax;
  var minRows = rows || rowsMinProp || minRowsProp;

  var _React$useRef = React__namespace.useRef(value != null),
      isControlled = _React$useRef.current;

  var inputRef = React__namespace.useRef(null);
  var handleRef = useIsFocusVisible.useForkRef(ref, inputRef);
  var shadowRef = React__namespace.useRef(null);
  var renders = React__namespace.useRef(0);

  var _React$useState = React__namespace.useState({}),
      state = _React$useState[0],
      setState = _React$useState[1];

  var syncHeight = React__namespace.useCallback(function () {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    var boxSizing = computedStyle['box-sizing'];
    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }

    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function (prevState) {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      if (process.env.NODE_ENV !== 'production') {
        if (renders.current === 20) {
          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
        }
      }

      return prevState;
    });
  }, [maxRows, minRows, props.placeholder]);
  React__namespace.useEffect(function () {
    var handleResize = debounce.debounce(function () {
      renders.current = 0;
      syncHeight();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect$1(function () {
    syncHeight();
  });
  React__namespace.useEffect(function () {
    renders.current = 0;
  }, [value]);

  var handleChange = function handleChange(event) {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("textarea", defaultTheme._extends({
    value: value,
    onChange: handleChange,
    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
    ,
    rows: minRows,
    style: defaultTheme._extends({
      height: state.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? 'hidden' : null
    }, style)
  }, other)), /*#__PURE__*/React__namespace.createElement("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: defaultTheme._extends({}, styles$e.shadow, style)
  }));
});
process.env.NODE_ENV !== "production" ? TextareaAutosize.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * Maximum number of rows to display.
   */
  maxRows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Minimum number of rows to display.
   */
  minRows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * @ignore
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  placeholder: defaultTheme.PropTypes.string,

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rows: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]), 'Use `minRows` instead.'),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]), 'Use `maxRows` instead.'),

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rowsMin: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]), 'Use `minRows` instead.'),

  /**
   * @ignore
   */
  style: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  value: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.arrayOf(defaultTheme.PropTypes.string), defaultTheme.PropTypes.number, defaultTheme.PropTypes.string])
} : void 0;

var styles$d = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: '0 !important'
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    '@global': {
      '@keyframes mui-auto-fill': {},
      '@keyframes mui-auto-fill-cancel': {}
    },

    /* Styles applied to the root element. */
    root: defaultTheme._extends({}, theme.typography.body1, {
      color: theme.palette.text.primary,
      lineHeight: '1.1876em',
      // Reset (19px), match the native input line-height
      boxSizing: 'border-box',
      // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    }),

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      '&$marginDense': {
        paddingTop: 4 - 1
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      letterSpacing: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      height: '1.1876em',
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      animationName: 'mui-auto-fill-cancel',
      animationDuration: '10ms',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      },
      '&:-webkit-autofill': {
        animationDuration: '5000s',
        animationName: 'mui-auto-fill'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: 'auto',
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},

    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? React__namespace.useEffect : React__namespace.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */

var InputBase = /*#__PURE__*/React__namespace.forwardRef(function InputBase(props, ref) {
  var ariaDescribedby = props['aria-describedby'],
      autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      classes = props.classes,
      className = props.className;
      props.color;
      var defaultValue = props.defaultValue,
      disabled = props.disabled,
      endAdornment = props.endAdornment;
      props.error;
      var _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      id = props.id,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$inputProps = props.inputProps,
      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
      inputRefProp = props.inputRef;
      props.margin;
      var _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      renderSuffix = props.renderSuffix,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMin = props.rowsMin,
      maxRows = props.maxRows,
      minRows = props.minRows,
      startAdornment = props.startAdornment,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      valueProp = props.value,
      other = defaultTheme._objectWithoutProperties(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "startAdornment", "type", "value"]);

  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;

  var _React$useRef = React__namespace.useRef(value != null),
      isControlled = _React$useRef.current;

  var inputRef = React__namespace.useRef();
  var handleInputRefWarning = React__namespace.useCallback(function (instance) {
    if (process.env.NODE_ENV !== 'production') {
      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
        console.error(['Material-UI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  var handleInputPropsRefProp = useIsFocusVisible.useForkRef(inputPropsProp.ref, handleInputRefWarning);
  var handleInputRefProp = useIsFocusVisible.useForkRef(inputRefProp, handleInputPropsRefProp);
  var handleInputRef = useIsFocusVisible.useForkRef(inputRef, handleInputRefProp);

  var _React$useState = React__namespace.useState(false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  var muiFormControl = useFormControl$1();

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__namespace.useEffect(function () {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }

      return undefined;
    }, [muiFormControl]);
  }

  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  React__namespace.useEffect(function () {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  var onFilled = muiFormControl && muiFormControl.onFilled;
  var onEmpty = muiFormControl && muiFormControl.onEmpty;
  var checkDirty = React__namespace.useCallback(function (obj) {
    if (isFilled(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect(function () {
    if (isControlled) {
      checkDirty({
        value: value
      });
    }
  }, [value, checkDirty, isControlled]);

  var handleFocus = function handleFocus(event) {
    // Fix a bug with IE 11 where the focus/blur events are triggered
    // while the input is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      var element = event.target || inputRef.current;

      if (element == null) {
        throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info." : defaultTheme.formatMuiErrorMessage(1));
      }

      checkDirty({
        value: element.value
      });
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
    } // Perform in the willUpdate


    if (onChange) {
      onChange.apply(void 0, [event].concat(args));
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  React__namespace.useEffect(function () {
    checkDirty(inputRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(event) {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  var InputComponent = inputComponent;

  var inputProps = defaultTheme._extends({}, inputPropsProp, {
    ref: handleInputRef
  });

  if (typeof InputComponent !== 'string') {
    inputProps = defaultTheme._extends({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type: type
    }, inputProps, {
      ref: null
    });
  } else if (multiline) {
    if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) {
      InputComponent = 'textarea';
    } else {
      inputProps = defaultTheme._extends({
        minRows: rows || minRows,
        rowsMax: rowsMax,
        maxRows: maxRows
      }, inputProps);
      InputComponent = TextareaAutosize;
    }
  } else {
    inputProps = defaultTheme._extends({
      type: type
    }, inputProps);
  }

  var handleAutoFill = function handleAutoFill(event) {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };

  React__namespace.useEffect(function () {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  return /*#__PURE__*/React__namespace.createElement("div", defaultTheme._extends({
    className: withStyles.clsx(classes.root, classes["color".concat(capitalize.capitalize(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
    onClick: handleClick,
    ref: ref
  }, other), startAdornment, /*#__PURE__*/React__namespace.createElement(FormControlContext.Provider, {
    value: null
  }, /*#__PURE__*/React__namespace.createElement(InputComponent, defaultTheme._extends({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: fcs.disabled,
    id: id,
    onAnimationStart: handleAutoFill,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    required: fcs.required,
    rows: rows,
    value: value,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }, inputProps, {
    className: withStyles.clsx(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }))), endAdornment, renderSuffix ? renderSuffix(defaultTheme._extends({}, fcs, {
    startAdornment: startAdornment
  })) : null);
});
process.env.NODE_ENV !== "production" ? InputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  'aria-describedby': defaultTheme.PropTypes.string,

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: defaultTheme.PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: defaultTheme.PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: defaultTheme.PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: defaultTheme.PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: defaultTheme.PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: defaultTheme.PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: defaultTheme.PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: defaultTheme.PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: tooltip.refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: defaultTheme.PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: defaultTheme.PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: defaultTheme.PropTypes.string,

  /**
   * Callback fired when the input is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onClick: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onFocus: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: defaultTheme.PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: defaultTheme.PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  renderSuffix: defaultTheme.PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rowsMin: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: defaultTheme.PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: defaultTheme.PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: defaultTheme.PropTypes.any
} : void 0;
var InputBase$1 = withStyles.withStyles(styles$d, {
  name: 'MuiInputBase'
})(InputBase);

var styles$c = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};
var Input = /*#__PURE__*/React__namespace.forwardRef(function Input(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = defaultTheme._objectWithoutProperties(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/React__namespace.createElement(InputBase$1, defaultTheme._extends({
    classes: defaultTheme._extends({}, classes, {
      root: withStyles.clsx(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
process.env.NODE_ENV !== "production" ? Input.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: defaultTheme.PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: defaultTheme.PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: defaultTheme.PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: defaultTheme.PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: defaultTheme.PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: defaultTheme.PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: defaultTheme.PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: defaultTheme.PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: defaultTheme.PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: tooltip.refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: defaultTheme.PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: defaultTheme.PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: defaultTheme.PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: defaultTheme.PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: defaultTheme.PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: defaultTheme.PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: defaultTheme.PropTypes.any
} : void 0;
Input.muiName = 'Input';
var Input$1 = withStyles.withStyles(styles$c, {
  name: 'MuiInput'
})(Input);

/**
 * @ignore - internal component.
 */

var NativeSelectInput = /*#__PURE__*/React__namespace.forwardRef(function NativeSelectInput(props, ref) {
  var classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = defaultTheme._objectWithoutProperties(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);

  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("select", defaultTheme._extends({
    className: withStyles.clsx(classes.root, // TODO v5: merge root and select
    classes.select, classes[variant], className, disabled && classes.disabled),
    disabled: disabled,
    ref: inputRef || ref
  }, other)), props.multiple ? null : /*#__PURE__*/React__namespace.createElement(IconComponent, {
    className: withStyles.clsx(classes.icon, classes["icon".concat(capitalize.capitalize(variant))], disabled && classes.disabled)
  }));
});
process.env.NODE_ENV !== "production" ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: defaultTheme.PropTypes.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: defaultTheme.PropTypes.elementType.isRequired,

  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: tooltip.refType,

  /**
   * @ignore
   */
  multiple: defaultTheme.PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: defaultTheme.PropTypes.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * The input value.
   */
  value: defaultTheme.PropTypes.any,

  /**
   * The variant to use.
   */
  variant: defaultTheme.PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;

var styles$b = function styles(theme) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},

    /* Styles applied to the select component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      },
      '&[multiple]': {
        height: 'auto'
      },
      '&:not([multiple]) option, &:not([multiple]) optgroup': {
        backgroundColor: theme.palette.background.paper
      },
      '&&': {
        paddingRight: 24
      }
    },

    /* Styles applied to the select component if `variant="filled"`. */
    filled: {
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: theme.shape.borderRadius,
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: 'auto',
      // Resets for multpile select with chips
      minHeight: '1.1876em',
      // Required for select\text-field height consistency
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },

    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},

    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      pointerEvents: 'none',
      // Don't block pointer events on the select under the icon.
      color: theme.palette.action.active,
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },

    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    },

    /* Styles applied to the underlying native input component. */
    nativeInput: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      opacity: 0,
      pointerEvents: 'none',
      width: '100%'
    }
  };
};
var defaultInput = /*#__PURE__*/React__namespace.createElement(Input$1, null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */

var NativeSelect = /*#__PURE__*/React__namespace.forwardRef(function NativeSelect(props, ref) {
  var children = props.children,
      classes = props.classes,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? ArrowDropDownIcon$1 : _props$IconComponent,
      _props$input = props.input,
      input = _props$input === void 0 ? defaultInput : _props$input,
      inputProps = props.inputProps;
      props.variant;
      var other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);

  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return /*#__PURE__*/React__namespace.cloneElement(input, defaultTheme._extends({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: NativeSelectInput,
    inputProps: defaultTheme._extends({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? NativeSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: defaultTheme.PropTypes.elementType,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: defaultTheme.PropTypes.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: defaultTheme.PropTypes.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * The input value. The DOM API casts this to a string.
   */
  value: defaultTheme.PropTypes.any,

  /**
   * The variant to use.
   */
  variant: defaultTheme.PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
NativeSelect.muiName = 'Select';
withStyles.withStyles(styles$b, {
  name: 'MuiNativeSelect'
})(NativeSelect);

var styles$a = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '27px 12px 10px',
      '&$marginDense': {
        paddingTop: 23,
        paddingBottom: 6
      }
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '27px 12px 10px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },

    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      '&$inputMarginDense': {
        paddingTop: 10,
        paddingBottom: 11
      }
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var FilledInput = /*#__PURE__*/React__namespace.forwardRef(function FilledInput(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = defaultTheme._objectWithoutProperties(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/React__namespace.createElement(InputBase$1, defaultTheme._extends({
    classes: defaultTheme._extends({}, classes, {
      root: withStyles.clsx(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
process.env.NODE_ENV !== "production" ? FilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: defaultTheme.PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: defaultTheme.PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: defaultTheme.PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: defaultTheme.PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: defaultTheme.PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: defaultTheme.PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: defaultTheme.PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: defaultTheme.PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: defaultTheme.PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: tooltip.refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: defaultTheme.PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: defaultTheme.PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: defaultTheme.PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: defaultTheme.PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: defaultTheme.PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: defaultTheme.PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: defaultTheme.PropTypes.any
} : void 0;
FilledInput.muiName = 'Input';
var FilledInput$1 = withStyles.withStyles(styles$a, {
  name: 'MuiFilledInput'
})(FilledInput);

var styles$9 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: '0 8px',
      pointerEvents: 'none',
      borderRadius: 'inherit',
      borderStyle: 'solid',
      borderWidth: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the legend element when `labelWidth` is provided. */
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '11px',
      // sync with `height` in `legend` styles
      transition: theme.transitions.create('width', {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the legend element. */
    legendLabelled: {
      display: 'block',
      width: 'auto',
      textAlign: 'left',
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: '0.75em',
      visibility: 'hidden',
      maxWidth: 0.01,
      transition: theme.transitions.create('max-width', {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      '& > span': {
        paddingLeft: 5,
        paddingRight: 5,
        display: 'inline-block'
      }
    },

    /* Styles applied to the legend element is notched. */
    legendNotched: {
      maxWidth: 1000,
      transition: theme.transitions.create('max-width', {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
};
/**
 * @ignore - internal component.
 */

var NotchedOutline = /*#__PURE__*/React__namespace.forwardRef(function NotchedOutline(props, ref) {
  props.children;
      var classes = props.classes,
      className = props.className,
      label = props.label,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);

  var theme = useTheme.useTheme();
  var align = theme.direction === 'rtl' ? 'right' : 'left';

  if (label !== undefined) {
    return /*#__PURE__*/React__namespace.createElement("fieldset", defaultTheme._extends({
      "aria-hidden": true,
      className: withStyles.clsx(classes.root, className),
      ref: ref,
      style: style
    }, other), /*#__PURE__*/React__namespace.createElement("legend", {
      className: withStyles.clsx(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/React__namespace.createElement("span", null, label) : /*#__PURE__*/React__namespace.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: '&#8203;'
      }
    })));
  }

  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
  return /*#__PURE__*/React__namespace.createElement("fieldset", defaultTheme._extends({
    "aria-hidden": true,
    style: defaultTheme._extends(defaultTheme._defineProperty({}, "padding".concat(capitalize.capitalize(align)), 8), style),
    className: withStyles.clsx(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/React__namespace.createElement("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, /*#__PURE__*/React__namespace.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
});
process.env.NODE_ENV !== "production" ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The label.
   */
  label: defaultTheme.PropTypes.node,

  /**
   * The width of the label.
   */
  labelWidth: defaultTheme.PropTypes.number.isRequired,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: defaultTheme.PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  style: defaultTheme.PropTypes.object
} : void 0;
var NotchedOutline$1 = withStyles.withStyles(styles$9, {
  name: 'PrivateNotchedOutline'
})(NotchedOutline);

var styles$8 = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        '&:hover $notchedOutline': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '18.5px 14px',
      '&$marginDense': {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: borderColor
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = /*#__PURE__*/React__namespace.forwardRef(function OutlinedInput(props, ref) {
  var classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      label = props.label,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      notched = props.notched,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = defaultTheme._objectWithoutProperties(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);

  return /*#__PURE__*/React__namespace.createElement(InputBase$1, defaultTheme._extends({
    renderSuffix: function renderSuffix(state) {
      return /*#__PURE__*/React__namespace.createElement(NotchedOutline$1, {
        className: classes.notchedOutline,
        label: label,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: defaultTheme._extends({}, classes, {
      root: withStyles.clsx(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
process.env.NODE_ENV !== "production" ? OutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: defaultTheme.PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: defaultTheme.PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: defaultTheme.PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: defaultTheme.PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: defaultTheme.PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: defaultTheme.PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: defaultTheme.PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: defaultTheme.PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: tooltip.refType,

  /**
   * The label of the input. It is only used for layout. The actual labelling
   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
   */
  label: defaultTheme.PropTypes.node,

  /**
   * The width of the label. Is ignored if `label` is provided. Prefer `label`
   * if the input label appears with a strike through.
   */
  labelWidth: defaultTheme.PropTypes.number,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: defaultTheme.PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: defaultTheme.PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: defaultTheme.PropTypes.string,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: defaultTheme.PropTypes.bool,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: defaultTheme.PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: defaultTheme.PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: defaultTheme.PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: defaultTheme.PropTypes.any
} : void 0;
OutlinedInput.muiName = 'Input';
var OutlinedInput$1 = withStyles.withStyles(styles$8, {
  name: 'MuiOutlinedInput'
})(OutlinedInput);

var styles$7 = styles$b;

var _ref$1 = /*#__PURE__*/React__namespace.createElement(Input$1, null);

var _ref2$1 = /*#__PURE__*/React__namespace.createElement(FilledInput$1, null);

var Select = /*#__PURE__*/React__namespace.forwardRef(function Select(props, ref) {
  var _props$autoWidth = props.autoWidth,
      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
      children = props.children,
      classes = props.classes,
      _props$displayEmpty = props.displayEmpty,
      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? ArrowDropDownIcon$1 : _props$IconComponent,
      id = props.id,
      input = props.input,
      inputProps = props.inputProps,
      label = props.label,
      labelId = props.labelId,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      MenuProps = props.MenuProps,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$native = props.native,
      native = _props$native === void 0 ? false : _props$native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      _props$variant = props.variant,
      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
      other = defaultTheme._objectWithoutProperties(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);

  var inputComponent = native ? NativeSelectInput : SelectInput;
  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  var variant = fcs.variant || variantProps;
  var InputComponent = input || {
    standard: _ref$1,
    outlined: /*#__PURE__*/React__namespace.createElement(OutlinedInput$1, {
      label: label,
      labelWidth: labelWidth
    }),
    filled: _ref2$1
  }[variant];
  return /*#__PURE__*/React__namespace.cloneElement(InputComponent, defaultTheme._extends({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: defaultTheme._extends({
      children: children,
      IconComponent: IconComponent,
      variant: variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: multiple
    }, native ? {
      id: id
    } : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      labelId: labelId,
      MenuProps: MenuProps,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: defaultTheme._extends({
        id: id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? withStyles.mergeClasses({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Select.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: defaultTheme.PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: defaultTheme.PropTypes.any,

  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
   * You can only use it when the `native` prop is `false` (default).
   */
  displayEmpty: defaultTheme.PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: defaultTheme.PropTypes.elementType,

  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: defaultTheme.PropTypes.string,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: defaultTheme.PropTypes.element,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: defaultTheme.PropTypes.object,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  label: defaultTheme.PropTypes.node,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: defaultTheme.PropTypes.string,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  labelWidth: defaultTheme.PropTypes.number,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: defaultTheme.PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: defaultTheme.PropTypes.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: defaultTheme.PropTypes.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: defaultTheme.PropTypes.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: defaultTheme.PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: defaultTheme.PropTypes.object,

  /**
   * The input value. Providing an empty string will select no options.
   * This prop is required when the `native` prop is `false` (default).
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: defaultTheme.PropTypes.any,

  /**
   * The variant to use.
   */
  variant: defaultTheme.PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
Select.muiName = 'Select';
var Select$1 = withStyles.withStyles(styles$7, {
  name: 'MuiSelect'
})(Select);

var variantComponent = {
  standard: Input$1,
  filled: FilledInput$1,
  outlined: OutlinedInput$1
};
var styles$6 = {
  /* Styles applied to the root element. */
  root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

var TextField = /*#__PURE__*/React__namespace.forwardRef(function TextField(props, ref) {
  var autoComplete = props.autoComplete,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      FormHelperTextProps = props.FormHelperTextProps,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      helperText = props.helperText,
      hiddenLabel = props.hiddenLabel,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      maxRows = props.maxRows,
      minRows = props.minRows,
      _props$select = props.select,
      select = _props$select === void 0 ? false : _props$select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = defaultTheme._objectWithoutProperties(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "maxRows", "minRows", "select", "SelectProps", "type", "value", "variant"]);

  if (process.env.NODE_ENV !== 'production') {
    if (select && !children) {
      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }

  var InputMore = {};

  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }

    if (label) {
      var _InputLabelProps$requ;

      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
      InputMore.label = /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, label, displayRequired && "\xA0*");
    }
  }

  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }

    InputMore['aria-describedby'] = undefined;
  }

  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var InputComponent = variantComponent[variant];
  var InputElement = /*#__PURE__*/React__namespace.createElement(InputComponent, defaultTheme._extends({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/React__namespace.createElement(FormControl$1, defaultTheme._extends({
    className: withStyles.clsx(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    ref: ref,
    required: required,
    color: color,
    variant: variant
  }, other), label && /*#__PURE__*/React__namespace.createElement(InputLabel$1, defaultTheme._extends({
    htmlFor: id,
    id: inputLabelId
  }, InputLabelProps), label), select ? /*#__PURE__*/React__namespace.createElement(Select$1, defaultTheme._extends({
    "aria-describedby": helperTextId,
    id: id,
    labelId: inputLabelId,
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/React__namespace.createElement(FormHelperText$1, defaultTheme._extends({
    id: helperTextId
  }, FormHelperTextProps), helperText));
});
process.env.NODE_ENV !== "production" ? TextField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: defaultTheme.PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default value of the `input` element.
   */
  defaultValue: defaultTheme.PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: defaultTheme.PropTypes.bool,

  /**
   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: defaultTheme.PropTypes.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: defaultTheme.PropTypes.bool,

  /**
   * The helper text content.
   */
  helperText: defaultTheme.PropTypes.node,

  /**
   * @ignore
   */
  hiddenLabel: defaultTheme.PropTypes.bool,

  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: defaultTheme.PropTypes.string,

  /**
   * Props applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: defaultTheme.PropTypes.object,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: defaultTheme.PropTypes.object,

  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/api/filled-input/),
   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: defaultTheme.PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: tooltip.refType,

  /**
   * The label content.
   */
  label: defaultTheme.PropTypes.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: defaultTheme.PropTypes.oneOf(['dense', 'none', 'normal']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Minimum number of rows to display.
   */
  minRows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: defaultTheme.PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: defaultTheme.PropTypes.string,

  /**
   * @ignore
   */
  onBlur: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onFocus: defaultTheme.PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: defaultTheme.PropTypes.string,

  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   * @deprecated Use `minRows` instead.
   */
  rows: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: defaultTheme.PropTypes.bool,

  /**
   * Props applied to the [`Select`](/api/select/) element.
   */
  SelectProps: defaultTheme.PropTypes.object,

  /**
   * The size of the text field.
   */
  size: defaultTheme.PropTypes.oneOf(['medium', 'small']),

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: defaultTheme.PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: defaultTheme.PropTypes.any,

  /**
   * The variant to use.
   */
  variant: defaultTheme.PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var TextField$1 = withStyles.withStyles(styles$6, {
  name: 'MuiTextField'
})(TextField);

var _templateObject$6, _templateObject2$2, _templateObject3$1, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
// typography
var inputFontSizeLabel = element.OwnUpBody;
var inputFontSizeHelp = element.OwnUpDetail;
var inputFontSizeError = element.OwnUpDetail;

// spacing
var inputFontSpacingHelp = '12px';
var inputFontSpacingError = '12px';
var inputBackgroundSpacingHorizontal = '20px';
var inputBackgroundSpacingTop = '20px';
var inputBackgroundSpacingTopEntry = '10px';
var inputBackgroundSpacingBottomEntry = '12px';

// radius
var inputBackgroundRadius = '4px';

// height
var inputHeight = '4rem';
var SvgWrapper = styled__default['default'].div(_templateObject$6 || (_templateObject$6 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  width: 44px;\n  position: absolute;\n  z-index: ", ";\n  display: flex;\n  align-items: center;\n  height: ", ";\n  padding-left: 20px;\n  & svg {\n    width: 20px;\n    height: 20px;\n  }\n  & svg path {\n    fill: ", ";\n  }\n"])), zIndices.Z_INDICES.FORM_ICONS, inputHeight, function (props) {
  return props.theme.inputColors.inputLeadingIconColor;
});
var RightSvgWrapper = styled__default['default'](SvgWrapper)(_templateObject2$2 || (_templateObject2$2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  position: relative;\n"])));
var textInputStyles = styled.css([".MuiInputBase-root{background-color:", ";}.MuiFilledInput-underline:not(.Mui-error):before,.MuiFilledInput-underline:not(.Mui-error):after{border-bottom:none;height:1px;background-color:", ";margin:auto;width:100%;border-radius:25px;}.MuiFilledInput-underline.Mui-error:before,.MuiFilledInput-underline.Mui-error:after{border-bottom:none;height:1px;background-color:", ";margin:auto;width:100%;border-radius:25px;}.MuiFilledInput-underline:not(.Mui-disabled):hover:before,.MuiFilledInput-underline:not(.Mui-disabled):hover:after,.MuiFilledInput-underline.Mui-focused:before,.MuiFilledInput-underline.Mui-focused:after{border-bottom:none;height:2px;background-color:", ";margin:auto;width:100%;border-radius:25px;}.MuiFilledInput-root{height:", ";}.MuiFormHelperText-root{", ";margin:", " ", " 0;color:", ";&.Mui-error{", "}}"], function (props) {
  return props.theme.inputColors.inputBackgroundColor;
}, function (props) {
  return props.theme.inputColors.inputUnderline;
}, colorPalette.BERRY_100, function (props) {
  return props.error ? props.theme.inputColors.inputIconColorError : props.theme.inputColors.inputUnderline;
}, inputHeight, inputFontSizeHelp, inputFontSpacingHelp, inputBackgroundSpacingHorizontal, function (props) {
  return props.theme.inputColors.inputFontColorHelp;
}, element.ownUpDetailMixin);
var DropdownTextInput = styled__default['default'](TextField$1)(_templateObject3$1 || (_templateObject3$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  .MuiAutocomplete-inputRoot[class*='MuiFilledInput-root'] .MuiAutocomplete-input {\n    padding: 0px;\n    padding-top: 0px;\n    padding-bottom: 12px;\n    padding-left: ", ";\n    ", "\n  }\n  .MuiAutocomplete-inputRoot[class*='MuiFilledInput-root'] {\n    padding-top: ", ";\n    padding-left: 0px;\n  }\n  .MuiInputAdornment-filled.MuiInputAdornment-positionEnd {\n    bottom: 20px;\n  }\n  .MuiAutocomplete-endAdornment {\n    top: calc(50% - 0.625rem);\n    width: ", ";\n    height: ", ";\n    line-height: 1.1876em;\n  }\n  .MuiAutocomplete-inputRoot[class*='MuiFilledInput-root'] .MuiAutocomplete-endAdornment {\n    right: 20px;\n  }\n  .MuiAutocomplete-popupIndicator {\n    margin-top: -2px;\n    padding: 0px;\n    &:hover {\n      background-color: transparent;\n    }\n    svg {\n      & path {\n        fill: ", ";\n      }\n    }\n  }\n  .MuiAutocomplete-clearIndicator {\n    display: none;\n  }\n"])), textInputStyles, inputPadding, function (_ref) {
  var placeholder = _ref.placeholder;
  return placeholder ? styled.css(["&.Mui-disabled{opacity:0.3;}"]) : styled.css([":not(.Mui-disabled){opacity:1;}"]);
}, function (props) {
  return props.labelPosition === 'outer' ? '12px' : '28px';
}, inputIconSizeDropdown, inputIconSizeDropdown, function (props) {
  return props.error ? props.theme.inputColors.inputIconColorError : props.theme.inputColors.inputUnderline;
});
var TextInput = styled__default['default'](TextField$1)(_templateObject4 || (_templateObject4 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  .MuiFilledInput-underline.Mui-disabled:before {\n    opacity: 0.4;\n  }\n  .MuiFormLabel-root {\n    ", ";\n    font-size: 1rem;\n  }\n  input {\n    font-size: 1rem;\n    height: ", ";\n    padding: ", ";\n  }\n  .MuiFilledInput-input {\n    ", ";\n    border-radius: ", " ", " 0 0;\n    color: ", ";\n  }\n  .MuiFormHelperText-root.Mui-error {\n    ", ";\n    margin-top: ", ";\n    color: ", ";\n  }\n  .MuiFilledInput-adornedStart {\n    background-color: ", ";\n    padding-left: 20px;\n\n    .MuiInputAdornment-positionStart {\n      & svg {\n        width: 20px;\n        height: 20px;\n      }\n      & svg path {\n        fill: ", ";\n      }\n    }\n  }\n  .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel) {\n    margin: 0;\n  }\n  .MuiFilledInput-adornedEnd {\n    background-color: ", ";\n    padding-right: 20px;\n    .MuiInputAdornment-positionEnd {\n      svg {\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n"])), textInputStyles, inputFontSizeLabel, function (props) {
  return props.labelPosition == 'outer' ? "calc(".concat(inputHeight, " - 2 * ").concat(inputBackgroundSpacingTop, ")") : "calc(".concat(inputHeight, " - (27px + ").concat(inputBackgroundSpacingBottomEntry, "))");
}, function (props) {
  if (props.labelPosition == 'outer' && props.$leadingIcon) {
    return "".concat(inputBackgroundSpacingTop, " ").concat(inputBackgroundSpacingHorizontal, " ").concat(inputBackgroundSpacingTop, " 16px");
  } else if (props.labelPosition == 'outer' && !props.$leadingIcon) {
    return "".concat(inputBackgroundSpacingTop);
  } else if (props.labelPosition == 'inner' && props.$leadingIcon) {
    return "27px ".concat(inputBackgroundSpacingHorizontal, " ").concat(inputBackgroundSpacingBottomEntry, " 56px");
  } else {
    return "27px ".concat(inputBackgroundSpacingHorizontal, " ").concat(inputBackgroundSpacingBottomEntry);
  }
}, inputFontSizeLabel, inputBackgroundRadius, inputBackgroundRadius, function (props) {
  return props.theme.inputColors.inputFontColorResponse;
}, inputFontSizeError, inputFontSpacingError, function (props) {
  return props.theme.inputColors.inputFontColorError;
}, function (props) {
  return props.theme.inputColors.inputBackgroundColor;
}, function (props) {
  return props.theme.inputColors.inputLeadingIconColor;
}, function (props) {
  return props.theme.inputColors.inputBackgroundColor;
});
var InputWrapper = styled__default['default'].div(_templateObject5 || (_templateObject5 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  .MuiInputLabel-filled {\n    ", ";\n    color: ", ";\n    transform: translate(", ", 25px) scale(1);\n  }\n  .MuiInputLabel-filled.MuiInputLabel-shrink {\n    line-height: 1.5rem;\n    color: ", ";\n    transform: translate(", ", ", ")\n      scale(0.75);\n  }\n  .Mui-disabled:not(.MuiFilledInput-input),\n  .Mui-disabled:not(.MuiInputBase-input) {\n    opacity: 0.4;\n  }\n  .MuiInputBase-input::-webkit-input-placeholder {\n    color: ", ";\n    font-style: italic;\n    opacity: 0.5;\n  }\n  .MuiInputLabel-formControl {\n    left: ", ";\n  }\n"])), inputFontSizeLabel, function (props) {
  return props.theme.inputColors.inputFontColorLabel;
}, inputBackgroundSpacingHorizontal, function (props) {
  return props.theme.inputColors.inputFontColorLabel;
}, inputBackgroundSpacingHorizontal, inputBackgroundSpacingTopEntry, function (props) {
  return props.theme.inputColors.inputFontColorHint;
}, function (props) {
  return props.labelPosition == 'inner' && props.$leadingIcon ? '36px' : '0';
});
var InputLabelText = styled__default['default'].label(_templateObject6 || (_templateObject6 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  color: ", ";\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 12px;\n  text-align: left;\n"])), function (props) {
  return props.theme.inputColors.inputFontColorLabelAbove;
});
var MainWrapper = styled__default['default'].div(_templateObject7 || (_templateObject7 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  position: relative;\n"])));

var _templateObject$5, _templateObject2$1, _templateObject3;
var outerLabelSelectorStyle = styled.css(["padding:", ";"], inputPadding);
var innerLabelSelectorStyle = styled.css(["line-height:", ";padding:calc(", " + ", ") ", " calc(", ") ", ";"], innerLabelFontSizeSelected, inputFontSpacingTopEntry, innerLabelFontSizeSelected, inputFontSpacingHorizontal, inputFontSpacingBottomEntry, inputFontSpacingHorizontal);
var selectedMixin = styled.css(["", " color:", ";"], element.ownUpBodyMixin, function (_ref) {
  var theme = _ref.theme;
  return theme.inputColors.inputFontColorResponse;
});
var unselectedMixin = styled.css(["", " line-height:", ";color:", ";"], element.ownUpBodyItalicMixin, inputFontSizePlaceholder, function (_ref2) {
  var theme = _ref2.theme;
  return theme.inputColors.inputFontColorPlaceholder;
});
var StyledSelect = styled__default['default'](Select$1)(_templateObject$5 || (_templateObject$5 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  & .MuiSelect-root {\n    background-color: ", ";\n    line-height: ", ";\n    border-radius: ", " ", " 0 0;\n\n    ", ";\n\n    ", "\n\n    ", "\n  }\n\n  & > svg {\n    position: absolute;\n    right: ", ";\n    pointer-events: none;\n    margin: 0;\n    width: ", ";\n    height: ", ";\n\n    & path {\n      fill: ", ";\n    }\n  }\n\n  &.Mui-error {\n    & > svg {\n      & path {\n        fill: ", ";\n      }\n    }\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.inputColors.inputBackgroundColor;
}, inputFontSizeResponse, inputBackgroundRadius$1, inputBackgroundRadius$1, function (_ref4) {
  var labelPosition = _ref4.labelPosition;
  return labelPosition === 'outer' ? outerLabelSelectorStyle : innerLabelSelectorStyle;
}, function (_ref5) {
  var value = _ref5.value;
  return value === '' ? unselectedMixin : selectedMixin;
}, inputRightPaddingMixin, inputFontSpacingHorizontal, inputIconSizeDropdown, inputIconSizeDropdown, function (_ref6) {
  var theme = _ref6.theme;
  return theme.inputColors.inputUnderline;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.inputColors.inputIconColorError;
});
var StyledMenuItem = styled__default['default'](MenuItem$1)(_templateObject2$1 || (_templateObject2$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  padding: ", ";\n  /* Don't allow placeholder elements to be selected */\n  &.placeholder {\n    display: none;\n  }\n  /* HACK: MUI injects its own \"Mui-selected\" classes\n   *   so use this selector instead to not cause conflicts */\n  &[aria-selected='true'] {\n    /* Override MUI style */\n    background-color: transparent;\n  }\n  &:hover,\n  &[aria-selected='true']:hover {\n    background-color: ", ";\n  }\n\n  &:focus,\n  &", ", &", ":hover {\n    background-color: ", ";\n  }\n"])), element.ownUpBodyMixin, function (_ref8) {
  var theme = _ref8.theme;
  return theme.inputColors.inputFontColorResponse;
}, inputBackgroundSpacing, function (_ref9) {
  var theme = _ref9.theme;
  return theme.inputColors.inputBackgroundColorHover;
}, focusVisibleSelector.focusVisibleSelectorMixin, focusVisibleSelector.focusVisibleSelectorMixin, function (_ref10) {
  var theme = _ref10.theme;
  return theme.inputColors.inputBackgroundColorFocus;
});

/**
 * Like tooltip popups, dropdown menus are rendered outside of its parent
 *   element so we must use Material's style engine to override its styles.
 */
var dropdownMenuStyles = tooltip.makeStyles(function () {
  // Dropdown menu styles are forced to the white theme.
  var theme = element$1.ownUpWhiteTheme;
  var borderStyle = "1px solid ".concat(theme.inputColors.inputBorderColor);
  var borderRadiusStyle = "".concat(inputBackgroundRadiusTop, " ").concat(inputBackgroundRadiusTop, " ").concat(inputBackgroundRadiusBottom, " ").concat(inputBackgroundRadiusBottom);
  var commonScrollbarStyles = {
    borderRadius: "calc(".concat(inputScrollbarSpacing, " * 2)"),
    // HACK: There is no webkit support for scrollbar padding so we
    //   simulate it by adding a border to the scrollbar.
    border: "".concat(inputScrollbarSpacing, " solid transparent"),
    // Ensures the element does not render over its own transparent
    //   border.
    backgroundClip: 'padding-box'
  };
  return {
    paper: function paper(_ref11) {
      var menuPosition = _ref11.menuPosition;
      // Styles for specific anchoring contexts
      var positionStyles = {
        borderTop: borderStyle,
        borderBottom: borderStyle,
        borderLeft: borderStyle,
        borderRight: borderStyle,
        borderRadius: borderRadiusStyle
      };
      if (menuPosition === 'top') {
        positionStyles.marginTop = '-1px';
        positionStyles.borderBottom = '0';
        positionStyles.borderRadius = "".concat(inputBackgroundRadiusTop, " ").concat(inputBackgroundRadiusTop, " 0 0");
      } else if (menuPosition === 'bottom') {
        positionStyles.marginTop = '-1px';
        positionStyles.borderTop = '0';
        positionStyles.borderRadius = "0 0 ".concat(inputBackgroundRadiusBottom, " ").concat(inputBackgroundRadiusBottom);
      }
      // Only apply position styles when the menu is actually anchored to the menu,
      //   which doesn't always happen if the screen is too small.
      var menuIsAttachedSelector = menuPosition === 'bottom' ?
      // Only use the attached style when the popover has not drifted from the element
      "&[style*='transform-origin: 0px 0px']" :
      // Always use the attached style
      '&';
      return _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({
        backgroundColor: theme.inputColors.inputBackgroundColorActive,
        boxShadow: "4.0px 4.0px 8.0px 0px ".concat(colorPalette.CHARCOAL_5),
        border: borderStyle,
        '&.MuiAutocomplete-paper': {
          margin: 0
        }
      }, menuIsAttachedSelector, positionStyles), '&::-webkit-scrollbar', {
        // HACK: Add extra width to the scrollbar to account for the border.
        width: "calc((".concat(inputScrollbarSpacing, " * 2) + ").concat(inputScrollbarWidth, ")")
      }), '&::-webkit-scrollbar-track', _rollupPluginBabelHelpers._objectSpread2({
        backgroundColor: theme.inputColors.inputBackgroundColorHover
      }, commonScrollbarStyles)), '&::-webkit-scrollbar-thumb', _rollupPluginBabelHelpers._objectSpread2({
        backgroundColor: theme.palette.primary.main
      }, commonScrollbarStyles));
    },
    option: {
      zIndex: zIndices.Z_INDICES.DROPDOWN_OPTIONS,
      width: '100%',
      '&.MuiAutocomplete-option': {
        padding: 0
      },
      '&.MuiAutocomplete-option[aria-selected="true"], &.MuiAutocomplete-option[data-focus="true"]': {
        backgroundColor: theme.inputColors.inputBackgroundColorHover
      }
    },
    noOptions: {
      '&.MuiAutocomplete-noOptions': {
        color: theme.inputColors.inputFontColorResponse,
        padding: inputBackgroundSpacing,
        // Cannot use mixin here since makeStyles does
        //  not support styled-component's css objects
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '0.01em',
        fontFamily: 'Aktiv-Grotesk-Regular, Helvetica, sans-serif',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal'
      }
    },
    listbox: {
      '&.MuiAutocomplete-listbox': _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({
        padding: 0,
        // Note: the height of the autoscroll depends on
        //  this max-height
        maxHeight: '300px'
      }, '&::-webkit-scrollbar', {
        width: "calc((".concat(inputScrollbarSpacing, " * 2) + ").concat(inputScrollbarWidth, ")")
      }), '&::-webkit-scrollbar-track', _rollupPluginBabelHelpers._objectSpread2({
        backgroundColor: theme.inputColors.inputBackgroundColorHover
      }, commonScrollbarStyles)), '&::-webkit-scrollbar-thumb', _rollupPluginBabelHelpers._objectSpread2({
        backgroundColor: theme.palette.primary.main
      }, commonScrollbarStyles))
    },
    list: function list(_ref13) {
      _rollupPluginBabelHelpers._objectDestructuringEmpty(_ref13);
      return {
        padding: 0
      };
    }
  };
});

// Filter Dropdowns
var StyledDropdownTextInput = styled__default['default'](DropdownTextInput)(_templateObject3 || (_templateObject3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  /** \n  * The \"hasValue\" prop is used to track when an option is selected (i.e. \"value !==''\" ),\n  *  but does not track the value when the user is typing (ie \"hasValue=false\" in this case).\n  */\n  ", "\n"])), function (_ref14) {
  var placeholder = _ref14.placeholder,
    hasValue = _ref14.hasValue;
  return placeholder && !hasValue ? styled.css([".MuiAutocomplete-inputRoot{", "}.MuiInputBase-input{color:", ";}.MuiAutocomplete-inputFocused{&", "{opacity:1;}}"], unselectedMixin, function (_ref15) {
    var theme = _ref15.theme;
    return theme.inputColors.inputFontColorLabelAbove;
  }, focusVisibleSelector.focusVisibleSelectorMixin) : styled.css([".MuiAutocomplete-inputRoot{", "}"], selectedMixin);
});

/**
 * Determines which icon to show. Will show the down chevron unless
 *   the menu is bottom-anchored and open.
 *
 * @param menuPosition - position of the dropdown menu
 * @param isOpen - whether or not the menu is open
 * @returns - which icon to show
 */
var useChevronIcon = function useChevronIcon(menuPosition) {
  var isOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return React.useMemo(function () {
    return menuPosition === 'bottom' && isOpen ? iconLibrary_systemIcons_standardIcons_chevronUp.ChevronUpIcon : iconLibrary_systemIcons_standardIcons_chevronDown.ChevronDownIcon;
  }, [menuPosition, isOpen]);
};

var _excluded$6 = ["id", "menuPosition", "value", "label", "labelPosition", "helperText", "error", "inputLabelRef", "formHelperTextRef", "errorTextRef", "disabled", "disabledReason", "placeholder", "children", "open", "onOpen", "onClose"];
var OwnUpMenuItem = function OwnUpMenuItem(props) {
  //  Menu elements are forced to the white theme
  return /*#__PURE__*/React__default['default'].createElement(element$1.OwnUpThemeProvider, {
    theme: element$1.ownUpWhiteTheme
  }, /*#__PURE__*/React__default['default'].createElement(StyledMenuItem, props));
};

/**
 * Build the anchor attributes when the position is set.
 */
var useAnchorProps = function useAnchorProps(menuPosition) {
  return React.useMemo(function () {
    if (menuPosition) {
      var anchorVert;
      var transformVert;
      switch (menuPosition) {
        case 'top':
          // Top-positioned popouts attach to the bottom of the
          //   element and anchor to the bottom of the menu
          anchorVert = 'bottom';
          transformVert = 'bottom';
          break;
        case 'bottom':
          // Bottom-positioned popouts attach to the bottom of the
          //   element and anchor to the top of the menu
          anchorVert = 'bottom';
          transformVert = 'top';
          break;
        default:
          // Center-positioned popouts attach to the center of the
          //   element and  anchor to the center of the menu
          anchorVert = 'center';
          transformVert = 'center';
          break;
      }
      return {
        // This function must explicitly be set to undefined in order to
        //   use custom anchoring rules.
        // See: https://github.com/mui-org/material-ui/pull/8948
        getContentAnchorEl: undefined,
        anchorOrigin: {
          horizontal: 'left',
          vertical: anchorVert
        },
        transformOrigin: {
          horizontal: 'left',
          vertical: transformVert
        }
      };
    }
    return undefined;
  }, [menuPosition]);
};
var OwnUpDropdown = function OwnUpDropdown(_ref) {
  var id = _ref.id,
    menuPosition = _ref.menuPosition,
    value = _ref.value,
    label = _ref.label,
    labelPosition = _ref.labelPosition,
    helperText = _ref.helperText,
    error = _ref.error,
    inputLabelRef = _ref.inputLabelRef,
    formHelperTextRef = _ref.formHelperTextRef,
    errorTextRef = _ref.errorTextRef,
    disabled = _ref.disabled,
    disabledReason = _ref.disabledReason,
    placeholder = _ref.placeholder,
    children = _ref.children,
    open = _ref.open,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$6);
  // In order to make sure our form control labels align, we need
  //   to ensure a label is provided. If the implementor does not
  //   provide one, we'll make one for them.
  var $inputId = hooks_useElementId.useElementId(id, 'select');
  // An id is required on the Mui selector outer element, but Mui
  //   will not generate a unique one if multiple are used, so we
  //   must generate them ourselves.
  var labelId = hooks_useRandomId.useRandomId('select-label');
  // Mui prefers to use dummy elements as placeholders.
  //   This will be hidden from the selection popup via CSS selectors
  var placeholderElement = React.useMemo(function () {
    return labelPosition === 'outer' && placeholder ? /*#__PURE__*/React__default['default'].createElement(OwnUpMenuItem, {
      className: "placeholder",
      value: "",
      disabled: true
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      "aria-placeholder": placeholder
    }, placeholder)) : undefined;
  }, [labelPosition, placeholder]);

  // Track the open state of this component
  var _useState = React.useState(open),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var onOpenWrapper = hooks_useWrappedFunction.useWrappedFunction(function () {
    return setOpen(true);
  }, onOpen);
  var onCloseWrapper = hooks_useWrappedFunction.useWrappedFunction(function () {
    return setOpen(false);
  }, onClose);

  // Figure out which icon to use
  var IconElement = useChevronIcon(menuPosition, isOpen);

  // Figure out the anchor configuration for this dropdown
  var anchorProps = useAnchorProps(menuPosition);
  var menuStyleClasses = dropdownMenuStyles({
    menuPosition: menuPosition
  });
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(OwnUpFormControl, {
    $inputId: $inputId,
    label: label,
    labelPosition: labelPosition,
    helperText: helperText,
    error: error,
    inputLabelRef: inputLabelRef,
    formHelperTextRef: formHelperTextRef,
    errorTextRef: errorTextRef,
    disabled: disabled,
    disabledReason: disabledReason,
    placeholder: placeholder
    // Always force the label to shrink when the menu is
    //   open or a value is selected. This override's
    //   MUI's behavior that keeps the label shrunk when
    //   clicking out of a menu but not picking anything.
    ,
    shrink: isOpen || !!value
  }, /*#__PURE__*/React__default['default'].createElement(StyledSelect, _rollupPluginBabelHelpers._extends({}, props, {
    id: labelId,
    MenuProps: _rollupPluginBabelHelpers._objectSpread2({
      classes: {
        paper: menuStyleClasses.paper,
        list: menuStyleClasses.list
      },
      MenuListProps: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'aria-labelledby': labelId
      }
    }, anchorProps),
    open: isOpen,
    onOpen: onOpenWrapper,
    onClose: onCloseWrapper,
    value: value,
    label: label,
    labelPosition: labelPosition,
    disabled: disabled
    // HACK: No matter which way I slice it the typing of this keeps
    //   resolving this as undefined rather than string, as if it's
    //   trying to resolve the original's "boolean" type and the
    //   overridden "string" type. There's no runtime problems here,
    //   just a typescript issue. Hopefully it'll be resolved in
    //   future iterations. - BC
    ,
    error: error,
    inputProps: {
      name: label,
      id: $inputId,
      placeholder: placeholder
    },
    displayEmpty: true,
    IconComponent: IconElement,
    endAdornment: error && /*#__PURE__*/React__default['default'].createElement(InputAdornment$1, {
      position: "end"
    }, /*#__PURE__*/React__default['default'].createElement(component.OwnUpIcon, {
      icon: iconLibrary_notificationIcons_errorLight.ErrorLightIcon
    }))
  }), placeholderElement, children)));
};

var styles$5 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },

    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};
var ListSubheader = /*#__PURE__*/React__namespace.forwardRef(function ListSubheader(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$disableSticky = props.disableSticky,
      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      other = defaultTheme._objectWithoutProperties(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);

  return /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    className: withStyles.clsx(classes.root, className, color !== 'default' && classes["color".concat(capitalize.capitalize(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListSubheader.propTypes = {
  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['default', 'primary', 'inherit']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the List Subheader will not have gutters.
   */
  disableGutters: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: defaultTheme.PropTypes.bool
} : void 0;
var ListSubheader$1 = withStyles.withStyles(styles$5, {
  name: 'MuiListSubheader'
})(ListSubheader);

/**
 * @ignore - internal component.
 */

var CancelIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

var styles$4 = function styles(theme) {
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = defaultTheme.alpha(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: 32 / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '& $avatar': {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
        fontSize: theme.typography.pxToRem(12)
      },
      '& $avatarColorPrimary': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark
      },
      '& $avatarColorSecondary': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.dark
      },
      '& $avatarSmall': {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: theme.typography.pxToRem(10)
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 24
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      userSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: defaultTheme.emphasize(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1]
      }
    },

    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
    clickableColorPrimary: {
      '&:hover, &:focus': {
        backgroundColor: defaultTheme.emphasize(theme.palette.primary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
    clickableColorSecondary: {
      '&:hover, &:focus': {
        backgroundColor: defaultTheme.emphasize(theme.palette.secondary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      '&:focus': {
        backgroundColor: defaultTheme.emphasize(backgroundColor, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      '&:focus': {
        backgroundColor: defaultTheme.emphasize(theme.palette.primary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      '&:focus': {
        backgroundColor: defaultTheme.emphasize(theme.palette.secondary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: defaultTheme.alpha(theme.palette.text.primary, theme.palette.action.hoverOpacity)
      },
      '& $avatar': {
        marginLeft: 4
      },
      '& $avatarSmall': {
        marginLeft: 2
      },
      '& $icon': {
        marginLeft: 4
      },
      '& $iconSmall': {
        marginLeft: 2
      },
      '& $deleteIcon': {
        marginRight: 5
      },
      '& $deleteIconSmall': {
        marginRight: 3
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(theme.palette.primary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: defaultTheme.alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(theme.palette.secondary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: defaultTheme.alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      }
    },
    // TODO v5: remove

    /* Styles applied to the `avatar` element. */
    avatar: {},

    /* Styles applied to the `avatar` element if `size="small"`. */
    avatarSmall: {},

    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {},

    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {},

    /* Styles applied to the `icon` element. */
    icon: {
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    },

    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      width: 18,
      height: 18,
      marginLeft: 4,
      marginRight: -4
    },

    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: 'inherit'
    },

    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: 'inherit'
    },

    /* Styles applied to the label `span` element. */
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the label `span` element if `size="small"`. */
    labelSmall: {
      paddingLeft: 8,
      paddingRight: 8
    },

    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      height: 22,
      width: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: defaultTheme.alpha(deleteIconColor, 0.4)
      }
    },

    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      height: 16,
      width: 16,
      marginRight: 4,
      marginLeft: -4
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: defaultTheme.alpha(theme.palette.primary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: defaultTheme.alpha(theme.palette.secondary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: defaultTheme.alpha(theme.palette.primary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: defaultTheme.alpha(theme.palette.secondary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.main
      }
    }
  };
};

function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


var Chip = /*#__PURE__*/React__namespace.forwardRef(function Chip(props, ref) {
  var avatarProp = props.avatar,
      classes = props.classes,
      className = props.className,
      clickableProp = props.clickable,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      ComponentProp = props.component,
      deleteIconProp = props.deleteIcon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      iconProp = props.icon,
      label = props.label,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      other = defaultTheme._objectWithoutProperties(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);

  var chipRef = React__namespace.useRef(null);
  var handleRef = useIsFocusVisible.useForkRef(chipRef, ref);

  var handleDeleteIconClick = function handleDeleteIconClick(event) {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }

    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  var clickable = clickableProp !== false && onClick ? true : clickableProp;
  var small = size === 'small';
  var Component = ComponentProp || (clickable ? iconButtons.ButtonBase : 'div');
  var moreProps = Component === iconButtons.ButtonBase ? {
    component: 'div'
  } : {};
  var deleteIcon = null;

  if (onDelete) {
    var customClasses = withStyles.clsx(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat(capitalize.capitalize(color))] : classes["deleteIconOutlinedColor".concat(capitalize.capitalize(color))]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && /*#__PURE__*/React__namespace.isValidElement(deleteIconProp) ? /*#__PURE__*/React__namespace.cloneElement(deleteIconProp, {
      className: withStyles.clsx(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /*#__PURE__*/React__namespace.createElement(CancelIcon, {
      className: withStyles.clsx(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }

  var avatar = null;

  if (avatarProp && /*#__PURE__*/React__namespace.isValidElement(avatarProp)) {
    avatar = /*#__PURE__*/React__namespace.cloneElement(avatarProp, {
      className: withStyles.clsx(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat(capitalize.capitalize(color))])
    });
  }

  var icon = null;

  if (iconProp && /*#__PURE__*/React__namespace.isValidElement(iconProp)) {
    icon = /*#__PURE__*/React__namespace.cloneElement(iconProp, {
      className: withStyles.clsx(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat(capitalize.capitalize(color))])
    });
  }

  if (process.env.NODE_ENV !== 'production') {
    if (avatar && icon) {
      console.error('Material-UI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }

  return /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    role: clickable || onDelete ? 'button' : undefined,
    className: withStyles.clsx(classes.root, className, color !== 'default' && [classes["color".concat(capitalize.capitalize(color))], clickable && classes["clickableColor".concat(capitalize.capitalize(color))], onDelete && classes["deletableColor".concat(capitalize.capitalize(color))]], variant !== "default" && [classes.outlined, {
      'primary': classes.outlinedPrimary,
      'secondary': classes.outlinedSecondary
    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
    "aria-disabled": disabled ? true : undefined,
    tabIndex: clickable || onDelete ? 0 : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, moreProps, other), avatar || icon, /*#__PURE__*/React__namespace.createElement("span", {
    className: withStyles.clsx(classes.label, small && classes.labelSmall)
  }, label), deleteIcon);
});
process.env.NODE_ENV !== "production" ? Chip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Avatar element.
   */
  avatar: defaultTheme.PropTypes.element,

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If false, the chip will not be clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   */
  clickable: defaultTheme.PropTypes.bool,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: defaultTheme.PropTypes.element,

  /**
   * If `true`, the chip should be displayed in a disabled state.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * Icon element.
   */
  icon: defaultTheme.PropTypes.element,

  /**
   * The content of the label.
   */
  label: defaultTheme.PropTypes.node,

  /**
   * @ignore
   */
  onClick: defaultTheme.PropTypes.func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: defaultTheme.PropTypes.func,

  /**
   * The size of the chip.
   */
  size: defaultTheme.PropTypes.oneOf(['medium', 'small']),

  /**
   * The variant to use.
   */
  variant: defaultTheme.PropTypes.oneOf(['default', 'outlined'])
} : void 0;
var Chip$1 = withStyles.withStyles(styles$4, {
  name: 'MuiChip'
})(Chip);

/**
 * @ignore - internal component.
 */

var CloseIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

/**
 * @ignore - internal component.
 */

var ArrowDropDownIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

// Give up on IE 11 support for this feature

function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}

function createFilterOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$ignoreAccents = config.ignoreAccents,
      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
      _config$ignoreCase = config.ignoreCase,
      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
      limit = config.limit,
      _config$matchFrom = config.matchFrom,
      matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
      stringify = config.stringify,
      _config$trim = config.trim,
      trim = _config$trim === void 0 ? false : _config$trim;
  return function (options, _ref) {
    var inputValue = _ref.inputValue,
        getOptionLabel = _ref.getOptionLabel;
    var input = trim ? inputValue.trim() : inputValue;

    if (ignoreCase) {
      input = input.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
    }

    var filteredOptions = options.filter(function (option) {
      var candidate = (stringify || getOptionLabel)(option);

      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
  };
} // To replace with .findIndex() once we stop IE 11 support.

function findIndex(array, comp) {
  for (var i = 0; i < array.length; i += 1) {
    if (comp(array[i])) {
      return i;
    }
  }

  return -1;
}

var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.

var pageSize = 5;
function useAutocomplete(props) {
  var _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
      _props$autoHighlight = props.autoHighlight,
      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
      _props$autoSelect = props.autoSelect,
      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
      _props$blurOnSelect = props.blurOnSelect,
      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
      _props$clearOnBlur = props.clearOnBlur,
      clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
      _props$clearOnEscape = props.clearOnEscape,
      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
      _props$componentName = props.componentName,
      componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName,
      _props$debug = props.debug,
      debug = _props$debug === void 0 ? false : _props$debug,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
      _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disableCloseOn = props.disableCloseOnSelect,
      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      _props$filterOptions = props.filterOptions,
      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
      _props$filterSelected = props.filterSelectedOptions,
      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      getOptionDisabled = props.getOptionDisabled,
      _props$getOptionLabel = props.getOptionLabel,
      getOptionLabelProp = _props$getOptionLabel === void 0 ? function (option) {
    return option;
  } : _props$getOptionLabel,
      _props$getOptionSelec = props.getOptionSelected,
      getOptionSelected = _props$getOptionSelec === void 0 ? function (option, value) {
    return option === value;
  } : _props$getOptionSelec,
      groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys,
      handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK,
      idProp = props.id,
      _props$includeInputIn = props.includeInputInList,
      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
      inputValueProp = props.inputValue,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      onChange = props.onChange,
      onClose = props.onClose,
      onHighlightChange = props.onHighlightChange,
      onInputChange = props.onInputChange,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$openOnFocus = props.openOnFocus,
      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
      options = props.options,
      _props$selectOnFocus = props.selectOnFocus,
      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
      valueProp = props.value;
  var id = tooltip.useId(idProp);
  var getOptionLabel = getOptionLabelProp;

  if (process.env.NODE_ENV !== 'production') {
    getOptionLabel = function getOptionLabel(option) {
      var optionLabel = getOptionLabelProp(option);

      if (typeof optionLabel !== 'string') {
        var erroneousReturn = optionLabel === undefined ? 'undefined' : "".concat(defaultTheme._typeof(optionLabel), " (").concat(optionLabel, ")");
        console.error("Material-UI: The `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(option), "."));
      }

      return optionLabel;
    };
  }

  var ignoreFocus = React__namespace.useRef(false);
  var firstFocus = React__namespace.useRef(true);
  var inputRef = React__namespace.useRef(null);
  var listboxRef = React__namespace.useRef(null);

  var _React$useState = React__namespace.useState(null),
      anchorEl = _React$useState[0],
      setAnchorEl = _React$useState[1];

  var _React$useState2 = React__namespace.useState(-1),
      focusedTag = _React$useState2[0],
      setFocusedTag = _React$useState2[1];

  var defaultHighlighted = autoHighlight ? 0 : -1;
  var highlightedIndexRef = React__namespace.useRef(defaultHighlighted);

  var _useControlled = tooltip.useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: componentName
  }),
      _useControlled2 = defaultTheme._slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var _useControlled3 = tooltip.useControlled({
    controlled: inputValueProp,
    default: '',
    name: componentName,
    state: 'inputValue'
  }),
      _useControlled4 = defaultTheme._slicedToArray(_useControlled3, 2),
      inputValue = _useControlled4[0],
      setInputValue = _useControlled4[1];

  var _React$useState3 = React__namespace.useState(false),
      focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var resetInputValue = iconButtons.useEventCallback(function (event, newValue) {
    var newInputValue;

    if (multiple) {
      newInputValue = '';
    } else if (newValue == null) {
      newInputValue = '';
    } else {
      var optionLabel = getOptionLabel(newValue);
      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
    }

    if (inputValue === newInputValue) {
      return;
    }

    setInputValue(newInputValue);

    if (onInputChange) {
      onInputChange(event, newInputValue, 'reset');
    }
  });
  React__namespace.useEffect(function () {
    resetInputValue(null, value);
  }, [value, resetInputValue]);

  var _useControlled5 = tooltip.useControlled({
    controlled: openProp,
    default: false,
    name: componentName,
    state: 'open'
  }),
      _useControlled6 = defaultTheme._slicedToArray(_useControlled5, 2),
      open = _useControlled6[0],
      setOpenState = _useControlled6[1];

  var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
  var popupOpen = open;
  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
    if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
      return value2 !== null && getOptionSelected(option, value2);
    })) {
      return false;
    }

    return true;
  }), // we use the empty string to manipulate `filterOptions` to not filter any options
  // i.e. the filter predicate always returns true
  {
    inputValue: inputValueIsSelectedValue ? '' : inputValue,
    getOptionLabel: getOptionLabel
  }) : [];

  if (process.env.NODE_ENV !== 'production') {
    if (value !== null && !freeSolo && options.length > 0) {
      var missingValue = (multiple ? value : [value]).filter(function (value2) {
        return !options.some(function (option) {
          return getOptionSelected(option, value2);
        });
      });

      if (missingValue.length > 0) {
        console.warn(["Material-UI: The value provided to ".concat(componentName, " is invalid."), "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."), 'You can use the `getOptionSelected` prop to customize the equality test.'].join('\n'));
      }
    }
  }

  var focusTag = iconButtons.useEventCallback(function (tagToFocus) {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
    }
  }); // Ensure the focusedTag is never inconsistent

  React__namespace.useEffect(function () {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);

  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute('aria-disabled') === 'true');

      if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) {
        // Move to the next element.
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var setHighlightedIndex = iconButtons.useEventCallback(function (_ref2) {
    var event = _ref2.event,
        index = _ref2.index,
        _ref2$reason = _ref2.reason,
        reason = _ref2$reason === void 0 ? 'auto' : _ref2$reason;
    highlightedIndexRef.current = index; // does the index exist?

    if (index === -1) {
      inputRef.current.removeAttribute('aria-activedescendant');
    } else {
      inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
    }

    if (onHighlightChange) {
      onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
    }

    if (!listboxRef.current) {
      return;
    }

    var prev = listboxRef.current.querySelector('[data-focus]');

    if (prev) {
      prev.removeAttribute('data-focus');
    }

    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"

    if (!listboxNode) {
      return;
    }

    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }

    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));

    if (!option) {
      return;
    }

    option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
    //
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });

    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse') {
      var element = option;
      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      var elementBottom = element.offsetTop + element.offsetHeight;

      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
      }
    }
  });
  var changeHighlightedIndex = iconButtons.useEventCallback(function (_ref3) {
    var event = _ref3.event,
        diff = _ref3.diff,
        _ref3$direction = _ref3.direction,
        direction = _ref3$direction === void 0 ? 'next' : _ref3$direction,
        _ref3$reason = _ref3.reason,
        reason = _ref3$reason === void 0 ? 'auto' : _ref3$reason;

    if (!popupOpen) {
      return;
    }

    var getNextIndex = function getNextIndex() {
      var maxIndex = filteredOptions.length - 1;

      if (diff === 'reset') {
        return defaultHighlighted;
      }

      if (diff === 'start') {
        return 0;
      }

      if (diff === 'end') {
        return maxIndex;
      }

      var newIndex = highlightedIndexRef.current + diff;

      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }

        return maxIndex;
      }

      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }

        return 0;
      }

      return newIndex;
    };

    var nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex({
      index: nextIndex,
      reason: reason,
      event: event
    }); // Sync the content of the input with the highlighted option.

    if (autoComplete && diff !== 'reset') {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        var option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.

        var index = option.toLowerCase().indexOf(inputValue.toLowerCase());

        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  });
  var syncHighlightedIndex = React__namespace.useCallback(function () {
    if (!popupOpen) {
      return;
    }

    var valueItem = multiple ? value[0] : value; // The popup is empty, reset

    if (filteredOptions.length === 0 || valueItem == null) {
      changeHighlightedIndex({
        diff: 'reset'
      });
      return;
    }

    if (!listboxRef.current) {
      return;
    } // Synchronize the value with the highlighted index


    if (!filterSelectedOptions && valueItem != null) {
      var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible

      if (multiple && currentOption && findIndex(value, function (val) {
        return getOptionSelected(currentOption, val);
      }) !== -1) {
        return;
      }

      var itemIndex = findIndex(filteredOptions, function (optionItem) {
        return getOptionSelected(optionItem, valueItem);
      });

      if (itemIndex === -1) {
        changeHighlightedIndex({
          diff: 'reset'
        });
      } else {
        setHighlightedIndex({
          index: itemIndex
        });
      }

      return;
    } // Prevent the highlighted index to leak outside the boundaries.


    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
      setHighlightedIndex({
        index: filteredOptions.length - 1
      });
      return;
    } // Restore the focus to the previous index.


    setHighlightedIndex({
      index: highlightedIndexRef.current
    }); // Ignore filteredOptions (and options, getOptionSelected, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [// Only sync the highlighted index when the option switch between empty and not
  // eslint-disable-next-line react-hooks/exhaustive-deps
  filteredOptions.length === 0, // Don't sync the highlighted index with the value when multiple
  // eslint-disable-next-line react-hooks/exhaustive-deps
  multiple ? false : value, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, popupOpen, inputValue, multiple]);
  var handleListboxRef = iconButtons.useEventCallback(function (node) {
    useIsFocusVisible.setRef(listboxRef, node);

    if (!node) {
      return;
    }

    syncHighlightedIndex();
  });
  React__namespace.useEffect(function () {
    syncHighlightedIndex();
  }, [syncHighlightedIndex]);

  var handleOpen = function handleOpen(event) {
    if (open) {
      return;
    }

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleClose = function handleClose(event, reason) {
    if (!open) {
      return;
    }

    setOpenState(false);

    if (onClose) {
      onClose(event, reason);
    }
  };

  var handleValue = function handleValue(event, newValue, reason, details) {
    if (value === newValue) {
      return;
    }

    if (onChange) {
      onChange(event, newValue, reason, details);
    }

    setValue(newValue);
  };

  var isTouch = React__namespace.useRef(false);

  var selectNewValue = function selectNewValue(event, option) {
    var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-option';
    var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
    var reason = reasonProp;
    var newValue = option;

    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];

      if (process.env.NODE_ENV !== 'production') {
        var matches = newValue.filter(function (val) {
          return getOptionSelected(option, val);
        });

        if (matches.length > 1) {
          console.error(["Material-UI: The `getOptionSelected` method of ".concat(componentName, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")].join('\n'));
        }
      }

      var itemIndex = findIndex(newValue, function (valueItem) {
        return getOptionSelected(option, valueItem);
      });

      if (itemIndex === -1) {
        newValue.push(option);
      } else if (origin !== 'freeSolo') {
        newValue.splice(itemIndex, 1);
        reason = 'remove-option';
      }
    }

    resetInputValue(event, newValue);
    handleValue(event, newValue, reason, {
      option: option
    });

    if (!disableCloseOnSelect) {
      handleClose(event, reason);
    }

    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
      inputRef.current.blur();
    }
  };

  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var handleFocusTag = function handleFocusTag(event, direction) {
    if (!multiple) {
      return;
    }

    handleClose(event, 'toggleInput');
    var nextTag = focusedTag;

    if (focusedTag === -1) {
      if (inputValue === '' && direction === 'previous') {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === 'next' ? 1 : -1;

      if (nextTag < 0) {
        nextTag = 0;
      }

      if (nextTag === value.length) {
        nextTag = -1;
      }
    }

    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };

  var handleClear = function handleClear(event) {
    ignoreFocus.current = true;
    setInputValue('');

    if (onInputChange) {
      onInputChange(event, '', 'clear');
    }

    handleValue(event, multiple ? [] : null, 'clear');
  };

  var handleKeyDown = function handleKeyDown(other) {
    return function (event) {
      if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
        setFocusedTag(-1);
        focusTag(-1);
      }

      switch (event.key) {
        case 'Home':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'start',
              direction: 'next',
              reason: 'keyboard',
              event: event
            });
          }

          break;

        case 'End':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'end',
              direction: 'previous',
              reason: 'keyboard',
              event: event
            });
          }

          break;

        case 'PageUp':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: -pageSize,
            direction: 'previous',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'PageDown':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: pageSize,
            direction: 'next',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowDown':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: 1,
            direction: 'next',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowUp':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: -1,
            direction: 'previous',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowLeft':
          handleFocusTag(event, 'previous');
          break;

        case 'ArrowRight':
          handleFocusTag(event, 'next');
          break;

        case 'Enter':
          // Wait until IME is settled.
          if (event.which === 229) {
            break;
          }

          if (highlightedIndexRef.current !== -1 && popupOpen) {
            var option = filteredOptions[highlightedIndexRef.current];
            var disabled = getOptionDisabled ? getOptionDisabled(option) : false; // We don't want to validate the form.

            event.preventDefault();

            if (disabled) {
              return;
            }

            selectNewValue(event, option, 'select-option'); // Move the selection to the end.

            if (autoComplete) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
            if (multiple) {
              // Allow people to add new values before they submit the form.
              event.preventDefault();
            }

            selectNewValue(event, inputValue, 'create-option', 'freeSolo');
          }

          break;

        case 'Escape':
          if (popupOpen) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClose(event, 'escape');
          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClear(event);
          }

          break;

        case 'Backspace':
          if (multiple && inputValue === '' && value.length > 0) {
            var index = focusedTag === -1 ? value.length - 1 : focusedTag;
            var newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'remove-option', {
              option: value[index]
            });
          }

          break;
      }

      if (other.onKeyDown) {
        other.onKeyDown(event);
      }
    };
  };

  var handleFocus = function handleFocus(event) {
    setFocused(true);

    if (openOnFocus && !ignoreFocus.current) {
      handleOpen(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    // Ignore the event when using the scrollbar with IE 11
    if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
      inputRef.current.focus();
      return;
    }

    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;

    if (debug && inputValue !== '') {
      return;
    }

    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
    } else if (autoSelect && freeSolo && inputValue !== '') {
      selectNewValue(event, inputValue, 'blur', 'freeSolo');
    } else if (clearOnBlur) {
      resetInputValue(event, value);
    }

    handleClose(event, 'blur');
  };

  var handleInputChange = function handleInputChange(event) {
    var newValue = event.target.value;

    if (inputValue !== newValue) {
      setInputValue(newValue);

      if (onInputChange) {
        onInputChange(event, newValue, 'input');
      }
    }

    if (newValue === '') {
      if (!disableClearable && !multiple) {
        handleValue(event, null, 'clear');
      }
    } else {
      handleOpen(event);
    }
  };

  var handleOptionMouseOver = function handleOptionMouseOver(event) {
    setHighlightedIndex({
      event: event,
      index: Number(event.currentTarget.getAttribute('data-option-index')),
      reason: 'mouse'
    });
  };

  var handleOptionTouchStart = function handleOptionTouchStart() {
    isTouch.current = true;
  };

  var handleOptionClick = function handleOptionClick(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    selectNewValue(event, filteredOptions[index], 'select-option');
    isTouch.current = false;
  };

  var handleTagDelete = function handleTagDelete(index) {
    return function (event) {
      var newValue = value.slice();
      newValue.splice(index, 1);
      handleValue(event, newValue, 'remove-option', {
        option: value[index]
      });
    };
  };

  var handlePopupIndicator = function handlePopupIndicator(event) {
    if (open) {
      handleClose(event, 'toggleInput');
    } else {
      handleOpen(event);
    }
  }; // Prevent input blur when interacting with the combobox


  var handleMouseDown = function handleMouseDown(event) {
    if (event.target.getAttribute('id') !== id) {
      event.preventDefault();
    }
  }; // Focus the input when interacting with the combobox


  var handleClick = function handleClick() {
    inputRef.current.focus();

    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.select();
    }

    firstFocus.current = false;
  };

  var handleInputMouseDown = function handleInputMouseDown(event) {
    if (inputValue === '' || !open) {
      handlePopupIndicator(event);
    }
  };

  var dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  var groupedOptions = filteredOptions;

  if (groupBy) {
    // used to keep track of key and indexes in the result array
    var indexBy = new Map();
    var warn = false;
    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
      var group = groupBy(option);

      if (acc.length > 0 && acc[acc.length - 1].group === group) {
        acc[acc.length - 1].options.push(option);
      } else {
        if (process.env.NODE_ENV !== 'production') {
          if (indexBy.get(group) && !warn) {
            console.warn("Material-UI: The options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), 'You can solve the issue by sorting the options with the output of `groupBy`.');
            warn = true;
          }

          indexBy.set(group, true);
        }

        acc.push({
          key: index,
          index: index,
          group: group,
          options: [option]
        });
      }

      return acc;
    }, []);
  }

  return {
    getRootProps: function getRootProps() {
      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return defaultTheme._extends({
        'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
        role: 'combobox',
        'aria-expanded': popupOpen
      }, other, {
        onKeyDown: handleKeyDown(other),
        onMouseDown: handleMouseDown,
        onClick: handleClick
      });
    },
    getInputLabelProps: function getInputLabelProps() {
      return {
        id: "".concat(id, "-label"),
        htmlFor: id
      };
    },
    getInputProps: function getInputProps() {
      return {
        id: id,
        value: inputValue,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleInputChange,
        onMouseDown: handleInputMouseDown,
        // if open then this is handled imperativeley so don't let react override
        // only have an opinion about this when closed
        'aria-activedescendant': popupOpen ? '' : null,
        'aria-autocomplete': autoComplete ? 'both' : 'list',
        'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
        // Disable browser's suggestion that might overlap with the popup.
        // Handle autocomplete but not autofill.
        autoComplete: 'off',
        ref: inputRef,
        autoCapitalize: 'none',
        spellCheck: 'false'
      };
    },
    getClearProps: function getClearProps() {
      return {
        tabIndex: -1,
        onClick: handleClear
      };
    },
    getPopupIndicatorProps: function getPopupIndicatorProps() {
      return {
        tabIndex: -1,
        onClick: handlePopupIndicator
      };
    },
    getTagProps: function getTagProps(_ref4) {
      var index = _ref4.index;
      return {
        key: index,
        'data-tag-index': index,
        tabIndex: -1,
        onDelete: handleTagDelete(index)
      };
    },
    getListboxProps: function getListboxProps() {
      return {
        role: 'listbox',
        id: "".concat(id, "-popup"),
        'aria-labelledby': "".concat(id, "-label"),
        ref: handleListboxRef,
        onMouseDown: function onMouseDown(event) {
          // Prevent blur
          event.preventDefault();
        }
      };
    },
    getOptionProps: function getOptionProps(_ref5) {
      var index = _ref5.index,
          option = _ref5.option;
      var selected = (multiple ? value : [value]).some(function (value2) {
        return value2 != null && getOptionSelected(option, value2);
      });
      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: index,
        tabIndex: -1,
        role: 'option',
        id: "".concat(id, "-option-").concat(index),
        onMouseOver: handleOptionMouseOver,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        'data-option-index': index,
        'aria-disabled': disabled,
        'aria-selected': selected
      };
    },
    id: id,
    inputValue: inputValue,
    value: value,
    dirty: dirty,
    popupOpen: popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl: anchorEl,
    setAnchorEl: setAnchorEl,
    focusedTag: focusedTag,
    groupedOptions: groupedOptions
  };
}

var styles$3 = function styles(theme) {
  var _option;

  return {
    /* Styles applied to the root element. */
    root: {
      '&$focused $clearIndicatorDirty': {
        visibility: 'visible'
      },

      /* Avoid double tap issue on iOS */
      '@media (pointer: fine)': {
        '&:hover $clearIndicatorDirty': {
          visibility: 'visible'
        }
      }
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Pseudo-class applied to the root element if focused. */
    focused: {},

    /* Styles applied to the tag elements, e.g. the chips. */
    tag: {
      margin: 3,
      maxWidth: 'calc(100% - 6px)'
    },

    /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */
    tagSizeSmall: {
      margin: 2,
      maxWidth: 'calc(100% - 4px)'
    },

    /* Styles applied when the popup icon is rendered. */
    hasPopupIcon: {},

    /* Styles applied when the clear icon is rendered. */
    hasClearIcon: {},

    /* Styles applied to the Input element. */
    inputRoot: {
      flexWrap: 'wrap',
      '$hasPopupIcon &, $hasClearIcon &': {
        paddingRight: 26 + 4
      },
      '$hasPopupIcon$hasClearIcon &': {
        paddingRight: 52 + 4
      },
      '& $input': {
        width: 0,
        minWidth: 30
      },
      '&[class*="MuiInput-root"]': {
        paddingBottom: 1,
        '& $input': {
          padding: 4
        },
        '& $input:first-child': {
          padding: '6px 0'
        }
      },
      '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
        '& $input': {
          padding: '4px 4px 5px'
        },
        '& $input:first-child': {
          padding: '3px 0 6px'
        }
      },
      '&[class*="MuiOutlinedInput-root"]': {
        padding: 9,
        '$hasPopupIcon &, $hasClearIcon &': {
          paddingRight: 26 + 4 + 9
        },
        '$hasPopupIcon$hasClearIcon &': {
          paddingRight: 52 + 4 + 9
        },
        '& $input': {
          padding: '9.5px 4px'
        },
        '& $input:first-child': {
          paddingLeft: 6
        },
        '& $endAdornment': {
          right: 9
        }
      },
      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
        padding: 6,
        '& $input': {
          padding: '4.5px 4px'
        }
      },
      '&[class*="MuiFilledInput-root"]': {
        paddingTop: 19,
        paddingLeft: 8,
        '$hasPopupIcon &, $hasClearIcon &': {
          paddingRight: 26 + 4 + 9
        },
        '$hasPopupIcon$hasClearIcon &': {
          paddingRight: 52 + 4 + 9
        },
        '& $input': {
          padding: '9px 4px'
        },
        '& $endAdornment': {
          right: 9
        }
      },
      '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
        paddingBottom: 1,
        '& $input': {
          padding: '4.5px 4px'
        }
      }
    },

    /* Styles applied to the input element. */
    input: {
      flexGrow: 1,
      textOverflow: 'ellipsis',
      opacity: 0
    },

    /* Styles applied to the input element if tag focused. */
    inputFocused: {
      opacity: 1
    },

    /* Styles applied to the endAdornment element. */
    endAdornment: {
      // We use a position absolute to support wrapping tags.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 14px)' // Center vertically

    },

    /* Styles applied to the clear indicator. */
    clearIndicator: {
      marginRight: -2,
      padding: 4,
      visibility: 'hidden'
    },

    /* Styles applied to the clear indicator if the input is dirty. */
    clearIndicatorDirty: {},

    /* Styles applied to the popup indicator. */
    popupIndicator: {
      padding: 2,
      marginRight: -2
    },

    /* Styles applied to the popup indicator if the popup is open. */
    popupIndicatorOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the popper element. */
    popper: {
      zIndex: theme.zIndex.modal
    },

    /* Styles applied to the popper element if `disablePortal={true}`. */
    popperDisablePortal: {
      position: 'absolute'
    },

    /* Styles applied to the `Paper` component. */
    paper: defaultTheme._extends({}, theme.typography.body1, {
      overflow: 'hidden',
      margin: '4px 0'
    }),

    /* Styles applied to the `listbox` component. */
    listbox: {
      listStyle: 'none',
      margin: 0,
      padding: '8px 0',
      maxHeight: '40vh',
      overflow: 'auto'
    },

    /* Styles applied to the loading wrapper. */
    loading: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the no option wrapper. */
    noOptions: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the option elements. */
    option: (_option = {
      minHeight: 48,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      cursor: 'pointer',
      paddingTop: 6,
      boxSizing: 'border-box',
      outline: '0',
      WebkitTapHighlightColor: 'transparent',
      paddingBottom: 6,
      paddingLeft: 16,
      paddingRight: 16
    }, defaultTheme._defineProperty(_option, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    }), defaultTheme._defineProperty(_option, '&[aria-selected="true"]', {
      backgroundColor: theme.palette.action.selected
    }), defaultTheme._defineProperty(_option, '&[data-focus="true"]', {
      backgroundColor: theme.palette.action.hover
    }), defaultTheme._defineProperty(_option, '&:active', {
      backgroundColor: theme.palette.action.selected
    }), defaultTheme._defineProperty(_option, '&[aria-disabled="true"]', {
      opacity: theme.palette.action.disabledOpacity,
      pointerEvents: 'none'
    }), _option),

    /* Styles applied to the group's label elements. */
    groupLabel: {
      backgroundColor: theme.palette.background.paper,
      top: -8
    },

    /* Styles applied to the group's ul elements. */
    groupUl: {
      padding: 0,
      '& $option': {
        paddingLeft: 24
      }
    }
  };
};

function DisablePortal(props) {
  // eslint-disable-next-line react/prop-types
  props.anchorEl;
      props.open;
      var other = defaultTheme._objectWithoutProperties(props, ["anchorEl", "open"]);

  return /*#__PURE__*/React__namespace.createElement("div", other);
}

var _ref = /*#__PURE__*/React__namespace.createElement(CloseIcon, {
  fontSize: "small"
});

var _ref2 = /*#__PURE__*/React__namespace.createElement(ArrowDropDownIcon, null);

var Autocomplete = /*#__PURE__*/React__namespace.forwardRef(function Autocomplete(props, ref) {
  /* eslint-disable no-unused-vars */
  props.autoComplete;
      props.autoHighlight;
      props.autoSelect;
      props.blurOnSelect;
      var ChipProps = props.ChipProps,
      classes = props.classes,
      className = props.className,
      _props$clearOnBlur = props.clearOnBlur;
      _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur;
      props.clearOnEscape;
      var _props$clearText = props.clearText,
      clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
      _props$closeIcon = props.closeIcon,
      closeIcon = _props$closeIcon === void 0 ? _ref : _props$closeIcon,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText;
      props.debug;
      var _props$defaultValue = props.defaultValue;
      _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue;
      var _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab;
      props.disableCloseOnSelect;
      var _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
      props.disabledItemsFocusable;
      props.disableListWrap;
      var _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal;
      props.filterOptions;
      props.filterSelectedOptions;
      var _props$forcePopupIcon = props.forcePopupIcon,
      forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$getLimitTagsTe = props.getLimitTagsText,
      getLimitTagsText = _props$getLimitTagsTe === void 0 ? function (more) {
    return "+".concat(more);
  } : _props$getLimitTagsTe;
      props.getOptionDisabled;
      var _props$getOptionLabel = props.getOptionLabel,
      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
    return x;
  } : _props$getOptionLabel;
      props.getOptionSelected;
      var groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys;
      _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK;
      props.id;
      props.includeInputInList;
      props.inputValue;
      var _props$limitTags = props.limitTags,
      limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags,
      _props$ListboxCompone = props.ListboxComponent,
      ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
      ListboxProps = props.ListboxProps,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$loadingText = props.loadingText,
      loadingText = _props$loadingText === void 0 ? 'Loading…' : _props$loadingText,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$noOptionsText = props.noOptionsText,
      noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText;
      props.onChange;
      props.onClose;
      props.onHighlightChange;
      props.onInputChange;
      props.onOpen;
      props.open;
      props.openOnFocus;
      var _props$openText = props.openText,
      openText = _props$openText === void 0 ? 'Open' : _props$openText;
      props.options;
      var _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? Paper.Paper : _props$PaperComponent,
      _props$PopperComponen = props.PopperComponent,
      PopperComponentProp = _props$PopperComponen === void 0 ? tooltip.Popper : _props$PopperComponen,
      _props$popupIcon = props.popupIcon,
      popupIcon = _props$popupIcon === void 0 ? _ref2 : _props$popupIcon,
      renderGroupProp = props.renderGroup,
      renderInput = props.renderInput,
      renderOptionProp = props.renderOption,
      renderTags = props.renderTags,
      _props$selectOnFocus = props.selectOnFocus;
      _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus;
      var _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size;
      props.value;
      var other = defaultTheme._objectWithoutProperties(props, ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "classes", "className", "clearOnBlur", "clearOnEscape", "clearText", "closeIcon", "closeText", "debug", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "getOptionSelected", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"]);
  /* eslint-enable no-unused-vars */


  var PopperComponent = disablePortal ? DisablePortal : PopperComponentProp;

  var _useAutocomplete = useAutocomplete(defaultTheme._extends({}, props, {
    componentName: 'Autocomplete'
  })),
      getRootProps = _useAutocomplete.getRootProps,
      getInputProps = _useAutocomplete.getInputProps,
      getInputLabelProps = _useAutocomplete.getInputLabelProps,
      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
      getClearProps = _useAutocomplete.getClearProps,
      getTagProps = _useAutocomplete.getTagProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getOptionProps = _useAutocomplete.getOptionProps,
      value = _useAutocomplete.value,
      dirty = _useAutocomplete.dirty,
      id = _useAutocomplete.id,
      popupOpen = _useAutocomplete.popupOpen,
      focused = _useAutocomplete.focused,
      focusedTag = _useAutocomplete.focusedTag,
      anchorEl = _useAutocomplete.anchorEl,
      setAnchorEl = _useAutocomplete.setAnchorEl,
      inputValue = _useAutocomplete.inputValue,
      groupedOptions = _useAutocomplete.groupedOptions;

  var startAdornment;

  if (multiple && value.length > 0) {
    var getCustomizedTagProps = function getCustomizedTagProps(params) {
      return defaultTheme._extends({
        className: withStyles.clsx(classes.tag, size === 'small' && classes.tagSizeSmall),
        disabled: disabled
      }, getTagProps(params));
    };

    if (renderTags) {
      startAdornment = renderTags(value, getCustomizedTagProps);
    } else {
      startAdornment = value.map(function (option, index) {
        return /*#__PURE__*/React__namespace.createElement(Chip$1, defaultTheme._extends({
          label: getOptionLabel(option),
          size: size
        }, getCustomizedTagProps({
          index: index
        }), ChipProps));
      });
    }
  }

  if (limitTags > -1 && Array.isArray(startAdornment)) {
    var more = startAdornment.length - limitTags;

    if (!focused && more > 0) {
      startAdornment = startAdornment.splice(0, limitTags);
      startAdornment.push( /*#__PURE__*/React__namespace.createElement("span", {
        className: classes.tag,
        key: startAdornment.length
      }, getLimitTagsText(more)));
    }
  }

  var defaultRenderGroup = function defaultRenderGroup(params) {
    return /*#__PURE__*/React__namespace.createElement("li", {
      key: params.key
    }, /*#__PURE__*/React__namespace.createElement(ListSubheader$1, {
      className: classes.groupLabel,
      component: "div"
    }, params.group), /*#__PURE__*/React__namespace.createElement("ul", {
      className: classes.groupUl
    }, params.children));
  };

  var renderGroup = renderGroupProp || defaultRenderGroup;
  var renderOption = renderOptionProp || getOptionLabel;

  var renderListOption = function renderListOption(option, index) {
    var optionProps = getOptionProps({
      option: option,
      index: index
    });
    return /*#__PURE__*/React__namespace.createElement("li", defaultTheme._extends({}, optionProps, {
      className: classes.option
    }), renderOption(option, {
      selected: optionProps['aria-selected'],
      inputValue: inputValue
    }));
  };

  var hasClearIcon = !disableClearable && !disabled;
  var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", defaultTheme._extends({
    ref: ref,
    className: withStyles.clsx(classes.root, className, focused && classes.focused, fullWidth && classes.fullWidth, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon)
  }, getRootProps(other)), renderInput({
    id: id,
    disabled: disabled,
    fullWidth: true,
    size: size === 'small' ? 'small' : undefined,
    InputLabelProps: getInputLabelProps(),
    InputProps: {
      ref: setAnchorEl,
      className: classes.inputRoot,
      startAdornment: startAdornment,
      endAdornment: /*#__PURE__*/React__namespace.createElement("div", {
        className: classes.endAdornment
      }, hasClearIcon ? /*#__PURE__*/React__namespace.createElement(IconButton.IconButton, defaultTheme._extends({}, getClearProps(), {
        "aria-label": clearText,
        title: clearText,
        className: withStyles.clsx(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
      }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/React__namespace.createElement(IconButton.IconButton, defaultTheme._extends({}, getPopupIndicatorProps(), {
        disabled: disabled,
        "aria-label": popupOpen ? closeText : openText,
        title: popupOpen ? closeText : openText,
        className: withStyles.clsx(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
      }), popupIcon) : null)
    },
    inputProps: defaultTheme._extends({
      className: withStyles.clsx(classes.input, focusedTag === -1 && classes.inputFocused),
      disabled: disabled
    }, getInputProps())
  })), popupOpen && anchorEl ? /*#__PURE__*/React__namespace.createElement(PopperComponent, {
    className: withStyles.clsx(classes.popper, disablePortal && classes.popperDisablePortal),
    style: {
      width: anchorEl ? anchorEl.clientWidth : null
    },
    role: "presentation",
    anchorEl: anchorEl,
    open: true
  }, /*#__PURE__*/React__namespace.createElement(PaperComponent, {
    className: classes.paper
  }, loading && groupedOptions.length === 0 ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.loading
  }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.noOptions
  }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/React__namespace.createElement(ListboxComponent, defaultTheme._extends({
    className: classes.listbox
  }, getListboxProps(), ListboxProps), groupedOptions.map(function (option, index) {
    if (groupBy) {
      return renderGroup({
        key: option.key,
        group: option.group,
        children: option.options.map(function (option2, index2) {
          return renderListOption(option2, option.index + index2);
        })
      });
    }

    return renderListOption(option, index);
  })) : null)) : null);
});
process.env.NODE_ENV !== "production" ? Autocomplete.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */
  autoComplete: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the first option is automatically highlighted.
   */
  autoHighlight: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */
  autoSelect: defaultTheme.PropTypes.bool,

  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   */
  blurOnSelect: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.oneOf(['mouse', 'touch']), defaultTheme.PropTypes.bool]),

  /**
   * Props applied to the [`Chip`](/api/chip/) element.
   */
  ChipProps: defaultTheme.PropTypes.object,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * If `true`, the input's text will be cleared on blur if no value is selected.
   *
   * Set to `true` if you want to help the user enter a new value.
   * Set to `false` if you want to help the user resume his search.
   */
  clearOnBlur: defaultTheme.PropTypes.bool,

  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */
  clearOnEscape: defaultTheme.PropTypes.bool,

  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  clearText: defaultTheme.PropTypes.string,

  /**
   * The icon to display in place of the default close icon.
   */
  closeIcon: defaultTheme.PropTypes.node,

  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: defaultTheme.PropTypes.string,

  /**
   * If `true`, the popup will ignore the blur event if the input is filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */
  debug: defaultTheme.PropTypes.bool,

  /**
   * The default input value. Use when the component is not controlled.
   */
  defaultValue: defaultTheme.PropTypes.any,

  /**
   * If `true`, the input can't be cleared.
   */
  disableClearable: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * If `true`, the popup won't close when a value is selected.
   */
  disableCloseOnSelect: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the input will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the list box in the popup will not wrap focus.
   */
  disableListWrap: defaultTheme.PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: defaultTheme.PropTypes.bool,

  /**
   * A filter function that determines the options that are eligible.
   *
   * @param {T[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {T[]}
   */
  filterOptions: defaultTheme.PropTypes.func,

  /**
   * If `true`, hide the selected options from the list box.
   */
  filterSelectedOptions: defaultTheme.PropTypes.bool,

  /**
   * Force the visibility display of the popup icon.
   */
  forcePopupIcon: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.oneOf(['auto']), defaultTheme.PropTypes.bool]),

  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */
  freeSolo: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: defaultTheme.PropTypes.bool,

  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   */
  getLimitTagsText: defaultTheme.PropTypes.func,

  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {T} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: defaultTheme.PropTypes.func,

  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * @param {T} option
   * @returns {string}
   */
  getOptionLabel: defaultTheme.PropTypes.func,

  /**
   * Used to determine if an option is selected, considering the current value.
   * Uses strict equality by default.
   *
   * @param {T} option The option to test.
   * @param {T} value The value to test against.
   * @returns {boolean}
   */
  getOptionSelected: defaultTheme.PropTypes.func,

  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {T} options The options to group.
   * @returns {string}
   */
  groupBy: defaultTheme.PropTypes.func,

  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   */
  handleHomeEndKeys: defaultTheme.PropTypes.bool,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: defaultTheme.PropTypes.string,

  /**
   * If `true`, the highlight can move to the input.
   */
  includeInputInList: defaultTheme.PropTypes.bool,

  /**
   * The input value.
   */
  inputValue: defaultTheme.PropTypes.string,

  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   */
  limitTags: defaultTheme.PropTypes.number,

  /**
   * The component used to render the listbox.
   */
  ListboxComponent: defaultTheme.PropTypes.elementType,

  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: defaultTheme.PropTypes.object,

  /**
   * If `true`, the component is in a loading state.
   */
  loading: defaultTheme.PropTypes.bool,

  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  loadingText: defaultTheme.PropTypes.node,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  noOptionsText: defaultTheme.PropTypes.node,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T|T[]} value The new value of the component.
   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"select-option"`, `"blur"`.
   */
  onClose: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the highlight option changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`.
   */
  onHighlightChange: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the input value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: defaultTheme.PropTypes.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: defaultTheme.PropTypes.func,

  /**
   * Control the popup` open state.
   */
  open: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the popup will open on input focus.
   */
  openOnFocus: defaultTheme.PropTypes.bool,

  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  openText: defaultTheme.PropTypes.string,

  /**
   * Array of options.
   */
  options: defaultTheme.PropTypes.array.isRequired,

  /**
   * The component used to render the body of the popup.
   */
  PaperComponent: defaultTheme.PropTypes.elementType,

  /**
   * The component used to position the popup.
   */
  PopperComponent: defaultTheme.PropTypes.elementType,

  /**
   * The icon to display in place of the default popup icon.
   */
  popupIcon: defaultTheme.PropTypes.node,

  /**
   * Render the group.
   *
   * @param {any} option The group to render.
   * @returns {ReactNode}
   */
  renderGroup: defaultTheme.PropTypes.func,

  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: defaultTheme.PropTypes.func.isRequired,

  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {T} option The option to render.
   * @param {object} state The state of the component.
   * @returns {ReactNode}
   */
  renderOption: defaultTheme.PropTypes.func,

  /**
   * Render the selected value.
   *
   * @param {T[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @returns {ReactNode}
   */
  renderTags: defaultTheme.PropTypes.func,

  /**
   * If `true`, the input's text will be selected on focus.
   * It helps the user clear the selected value.
   */
  selectOnFocus: defaultTheme.PropTypes.bool,

  /**
   * The size of the autocomplete.
   */
  size: defaultTheme.PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `getOptionSelected` prop.
   */
  value: defaultTheme.PropTypes.any
} : void 0;
var Autocomplete$1 = withStyles.withStyles(styles$3, {
  name: 'MuiAutocomplete'
})(Autocomplete);

var _excluded$5 = ["id", "menuPosition", "value", "label", "labelPosition", "helperText", "error", "inputLabelRef", "formHelperTextRef", "errorTextRef", "disabled", "disabledReason", "placeholder", "open", "onOpen", "onClose", "shrink", "options"];

/**
 * A dropdown that can have its results filtered out based on the user's input.
 *   Note that if the user removes their input completely, it will result in the
 *   the string 'null'.
 */
var OwnUpFilterDropdown = function OwnUpFilterDropdown(_ref) {
  var id = _ref.id,
    menuPosition = _ref.menuPosition,
    value = _ref.value,
    label = _ref.label,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'inner' : _ref$labelPosition,
    helperText = _ref.helperText,
    error = _ref.error,
    inputLabelRef = _ref.inputLabelRef,
    formHelperTextRef = _ref.formHelperTextRef,
    errorTextRef = _ref.errorTextRef,
    disabled = _ref.disabled,
    disabledReason = _ref.disabledReason,
    placeholder = _ref.placeholder,
    open = _ref.open,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose;
    _ref.shrink;
    var options = _ref.options,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$5);
  var $inputId = hooks_useElementId.useElementId(id, 'autocomplete');
  var _useState = React.useState(open),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    isFilterDropdownOpen = _useState2[0],
    setFilterDropdownOpen = _useState2[1];
  var onOpenWrapper = hooks_useWrappedFunction.useWrappedFunction(function (_) {
    return setFilterDropdownOpen(true);
  }, onOpen);
  var onCloseWrapper = hooks_useWrappedFunction.useWrappedFunction(function (_event, _reason) {
    return setFilterDropdownOpen(false);
  }, onClose);
  var IconElement = useChevronIcon(menuPosition, isFilterDropdownOpen);

  // Optional placeholder for outer label components
  var outerLabelPlaceholder = React.useMemo(function () {
    return labelPosition === 'outer' && placeholder ? placeholder : undefined;
  }, [labelPosition, placeholder]);
  var classes = dropdownMenuStyles({
    menuPosition: menuPosition
  });
  var CustomPopper = function CustomPopper(popperProps) {
    return /*#__PURE__*/React__default['default'].createElement(tooltip.Popper, _rollupPluginBabelHelpers._extends({}, popperProps, {
      placement: menuPosition
    }));
  };
  var _useState3 = React.useState(false),
    _useState4 = _rollupPluginBabelHelpers._slicedToArray(_useState3, 2),
    shrinkLabel = _useState4[0],
    setShrinkLabel = _useState4[1];
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(OwnUpFormControl, {
    $inputId: $inputId,
    label: label,
    labelPosition: labelPosition,
    helperText: helperText,
    error: error,
    inputLabelRef: inputLabelRef,
    formHelperTextRef: formHelperTextRef,
    errorTextRef: errorTextRef,
    disabled: disabled,
    disabledReason: disabledReason,
    placeholder: outerLabelPlaceholder,
    onClick: function onClick() {
      return setShrinkLabel(true);
    },
    onBlur: function onBlur() {
      return setShrinkLabel(false);
    }
    // Always force the label to shrink when the menu is
    //   open or a value is selected. This override's
    //   MUI's behavior that keeps the label shrunk when
    //   clicking out of a menu but not picking anything.
    ,
    shrink: isFilterDropdownOpen || shrinkLabel || !!value && value !== 'null'
  }, /*#__PURE__*/React__default['default'].createElement(Autocomplete$1, _rollupPluginBabelHelpers._extends({}, props, {
    id: $inputId,
    options: options,
    open: isFilterDropdownOpen,
    onOpen: onOpenWrapper,
    onClose: onCloseWrapper,
    popupIcon: /*#__PURE__*/React__default['default'].createElement(IconElement, null),
    closeIcon: false,
    disabled: disabled,
    value: value,
    classes: {
      paper: classes.paper,
      listbox: classes.listbox,
      option: classes.option,
      noOptions: classes.noOptions
    },
    PopperComponent: CustomPopper
    // Hack: when the search value is set to a "null" literal
    //  force it to reset to an empty string.
    ,
    getOptionLabel: function getOptionLabel(option) {
      return option === 'null' ? '' : option || '';
    },
    renderOption: function renderOption(option) {
      return /*#__PURE__*/React__default['default'].createElement(OwnUpMenuItem, {
        value: "".concat(option)
      }, option);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default['default'].createElement(StyledDropdownTextInput, _rollupPluginBabelHelpers._extends({}, params, {
        placeholder: outerLabelPlaceholder,
        labelPosition: labelPosition,
        hasValue: !!placeholder && !!params.inputProps.value
        // HACK: No matter which way I slice it the typing of this keeps
        //   resolving this as undefined rather than string, as if it's
        //   trying to resolve the original's "boolean" type and the
        //   overridden "string" type. There's no runtime problems here,
        //   just a typescript issue. Hopefully it'll be resolved in
        //   future iterations. - BC
        ,
        error: error,
        variant: "filled",
        InputProps: _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, params.InputProps), {}, {
          inputProps: _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, params.inputProps), {}, {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'aria-label': 'autocomplete-input',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'aria-invalid': error ? true : false
          }),
          // Hack: should be `endAdornment` but AutoComplete enforces its own
          //  `endAdornment` such that re-defining it hides the dropdown icons.
          startAdornment: error && /*#__PURE__*/React__default['default'].createElement(InputAdornment$1, {
            position: "end"
          }, /*#__PURE__*/React__default['default'].createElement(component.OwnUpIcon, {
            icon: iconLibrary_notificationIcons_errorLight.ErrorLightIcon
          }))
        })
      }));
    }
  }))));
};

var _templateObject$4;
var _excluded$4 = ["className", "detailProps", "children"];
var StandaloneErrorImpl = function StandaloneErrorImpl(_ref) {
  var className = _ref.className,
    detailProps = _ref.detailProps,
    children = _ref.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$4);
  var fullClassName = hooks_useCombinedClassName.useCombinedClassName('standalone-error', className);
  var currentTheme = styled.useTheme();
  return /*#__PURE__*/React__default['default'].createElement("div", _rollupPluginBabelHelpers._extends({
    className: fullClassName
  }, props), /*#__PURE__*/React__default['default'].createElement(component.OwnUpIcon, {
    height: "1.5rem",
    icon: currentTheme.name === 'own-up-midtone' ? iconLibrary_notificationIcons_errorDark.ErrorDarkIcon : iconLibrary_notificationIcons_errorLight.ErrorLightIcon
  }), /*#__PURE__*/React__default['default'].createElement(element.OwnUpDetail, _rollupPluginBabelHelpers._extends({
    variant: "body2"
  }, detailProps), children));
};

/**
 * A standalone error is a single block of error copy that is
 *   mainly meant to be inserted as part of a Checkbox or
 *   Radio Group component, alerting of the error.
 */
var StandaloneError = styled__default['default'](StandaloneErrorImpl)(_templateObject$4 || (_templateObject$4 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  color: ", ";\n  display: flex;\n  align-items: center;\n\n  margin: ", ";\n\n  & svg {\n    /* 16px to the right of the icon */\n    margin-right: ", ";\n  }\n  ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.errorContainerColors.inputFontColorError;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "0 0 ".concat(theme.spacing(1.5), "px ").concat(theme.spacing(2.5), "px");
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.spacing(2), "px");
}, function (_ref5) {
  var addedErrorStyle = _ref5.addedErrorStyle;
  return addedErrorStyle;
});

var _excluded$3 = ["showError", "errorText", "elements"];
var _templateObject$3;
var OptionsContainer = styled__default['default'].div(_templateObject$3 || (_templateObject$3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));

/**
 * Shows an error above checkboxes/radio buttons, if given conditions are met
 */
var OwnUpErrorContainer = function OwnUpErrorContainer(_ref) {
  var showError = _ref.showError,
    _ref$errorText = _ref.errorText,
    errorText = _ref$errorText === void 0 ? 'Please make a selection' : _ref$errorText,
    elements = _ref.elements,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, showError ? /*#__PURE__*/React__default['default'].createElement(StandaloneError, props, errorText) : null, /*#__PURE__*/React__default['default'].createElement(OptionsContainer, null, elements));
};

/**
 * @ignore - internal component.
 */

var RadioButtonUncheckedIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

/**
 * @ignore - internal component.
 */

var RadioButtonCheckedIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

var styles$2 = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      '&$checked $layer': {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      }
    },
    layer: {
      left: 0,
      position: 'absolute',
      transform: 'scale(0)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {}
  };
};
/**
 * @ignore - internal component.
 */

function RadioButtonIcon(props) {
  var checked = props.checked,
      classes = props.classes,
      fontSize = props.fontSize;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: withStyles.clsx(classes.root, checked && classes.checked)
  }, /*#__PURE__*/React__namespace.createElement(RadioButtonUncheckedIcon, {
    fontSize: fontSize
  }), /*#__PURE__*/React__namespace.createElement(RadioButtonCheckedIcon, {
    fontSize: fontSize,
    className: classes.layer
  }));
}

process.env.NODE_ENV !== "production" ? RadioButtonIcon.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: defaultTheme.PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object.isRequired,

  /**
   * The size of the radio.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: defaultTheme.PropTypes.oneOf(['small', 'medium'])
} : void 0;
var RadioButtonIcon$1 = withStyles.withStyles(styles$2, {
  name: 'PrivateRadioButtonIcon'
})(RadioButtonIcon);

/**
 * @ignore - internal component.
 */

var RadioGroupContext = React__namespace.createContext();

if (process.env.NODE_ENV !== 'production') {
  RadioGroupContext.displayName = 'RadioGroupContext';
}

function useRadioGroup() {
  return React__namespace.useContext(RadioGroupContext);
}

var styles$1 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: defaultTheme.alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: defaultTheme.alpha(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/React__namespace.createElement(RadioButtonIcon$1, {
  checked: true
});
var defaultIcon = /*#__PURE__*/React__namespace.createElement(RadioButtonIcon$1, null);
var Radio = /*#__PURE__*/React__namespace.forwardRef(function Radio(props, ref) {
  var checkedProp = props.checked,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      nameProp = props.name,
      onChangeProp = props.onChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = defaultTheme._objectWithoutProperties(props, ["checked", "classes", "color", "name", "onChange", "size"]);

  var radioGroup = useRadioGroup();
  var checked = checkedProp;
  var onChange = tooltip.createChainedFunction(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return /*#__PURE__*/React__namespace.createElement(SwitchBase$1, defaultTheme._extends({
    color: color,
    type: "radio",
    icon: /*#__PURE__*/React__namespace.cloneElement(defaultIcon, {
      fontSize: size === 'small' ? 'small' : 'medium'
    }),
    checkedIcon: /*#__PURE__*/React__namespace.cloneElement(defaultCheckedIcon, {
      fontSize: size === 'small' ? 'small' : 'medium'
    }),
    classes: {
      root: withStyles.clsx(classes.root, classes["color".concat(capitalize.capitalize(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Radio.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: defaultTheme.PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * If `true`, the radio will be disabled.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: defaultTheme.PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: defaultTheme.PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: defaultTheme.PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: defaultTheme.PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: tooltip.refType,

  /**
   * Name attribute of the `input` element.
   */
  name: defaultTheme.PropTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: defaultTheme.PropTypes.bool,

  /**
   * The size of the radio.
   * `small` is equivalent to the dense radio styling.
   */
  size: defaultTheme.PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: defaultTheme.PropTypes.any
} : void 0;
var MuiRadioButton = withStyles.withStyles(styles$1, {
  name: 'MuiRadio'
})(Radio);

var RadioButtonIconUnchecked = function RadioButtonIconUnchecked() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: 'ouRadioButtonUnchecked',
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    className: "outer",
    x: "1",
    y: "1",
    width: "22",
    height: "22",
    rx: "11",
    strokeWidth: "2"
  }));
};
var RadioButtonIconChecked = function RadioButtonIconChecked() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: 'ouRadioButtonChecked',
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default['default'].createElement("rect", {
    className: "outer",
    x: "1",
    y: "1",
    width: "22",
    height: "22",
    rx: "11",
    strokeWidth: "2"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    className: "inner",
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    rx: "8"
  }));
};

var _templateObject$2;
var StyledRadioLabel = styled__default['default'](FormControlLabel$1)(_templateObject$2 || (_templateObject$2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  background-color: ", ";\n\n  .Mui-disabled {\n    color: ", ";\n  }\n  &.Mui-disabled {\n    opacity: 40%;\n  }\n\n  .ouRadioButtonChecked {\n    & > rect.outer {\n      stroke: ", ";\n    }\n    & > rect.inner {\n      fill: ", ";\n    }\n  }\n\n  .ouRadioButtonUnchecked rect {\n    stroke: ", ";\n  }\n\n  &:hover:not(.Mui-disabled) {\n    .ouRadioButtonUnchecked rect {\n      fill: ", ";\n    }\n    .ouRadioButtonChecked rect.outer {\n      fill: ", ";\n    }\n  }\n\n  ", "\n"])), commonIconInputsMixin, function (_ref) {
  var theme = _ref.theme;
  return theme.radioButtonColors.radioButtonFontColorLabel;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.radioButtonColors.radioButtonColorBackground;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radioButtonColors.radioButtonFontColorLabel;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.radioButtonColors.radioButtonColorBorder;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.radioButtonColors.radioButtonColorBorder;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.radioButtonColors.radioButtonColorBorder;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.radioButtonColors.radioButtonColorHover;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.radioButtonColors.radioButtonColorHover;
}, function (_ref9) {
  var $focusVisible = _ref9.$focusVisible,
    theme = _ref9.theme;
  return $focusVisible ? styled.css(["&:not(:hover):not(.Mui-disabled){.ouRadioButtonUnchecked rect{fill:", ";}.ouRadioButtonChecked rect.outer{fill:", ";}}&", ""], theme.radioButtonColors.radioButtonColorFocus, function (_ref10) {
    var innerTheme = _ref10.theme;
    return innerTheme.radioButtonColors.radioButtonColorHover;
  }, elementOutline.createElementOutlineMixin({
    width: "".concat(theme.spacing(0.25), "px"),
    color: theme.radioButtonColors.radioButtonColorBorder,
    radius: "".concat(theme.shape.borderRadius, "px")
  })) : undefined;
});

var _excluded$2 = ["children", "width", "disabledReason", "labelRef"];

/**
 * Renders a checkbox.
 *
 * @remarks
 * This component leverages material-ui's Checkbox component {@link https://mui.com/components/checkboxes/}
 *
 * @param id - (optional) The element id
 * @param disabled - (optional) Boolean indicating whether the input should be in a disabled state
 * @param disabledReason - (optional) Message to display in a tooltip when the input is disabled
 * @param labelRef - (optional) ref to access <FormControlLabel>
 * @param width - (optional) CSS width value for the component
 * @returns A styled checkbox component
 *
 */
var OwnUpRadioButton = function OwnUpRadioButton(_ref) {
  var children = _ref.children,
    width = _ref.width,
    disabledReason = _ref.disabledReason,
    labelRef = _ref.labelRef,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$2);
  var _React$useState = React__default['default'].useState(false),
    _React$useState2 = _rollupPluginBabelHelpers._slicedToArray(_React$useState, 2),
    focusVisible = _React$useState2[0],
    setFocusVisible = _React$useState2[1];

  // Mimics disabled state, but still allows keyboard focus
  var inactiveProps = React.useMemo(function () {
    return {
      onChange: undefined,
      // Prevent field from being toggled
      disabled: false,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'aria-disabled': true,
      className: 'Mui-disabled',
      // easiest way to maintain disabled styling
      checked: props.checked || false // Lock the state as-is
    };
  }, [props.checked]);
  var radioButtonComponent = /*#__PURE__*/React__default['default'].createElement(StyledRadioLabel, _rollupPluginBabelHelpers._extends({
    width: width,
    $focusVisible: focusVisible
  }, props.disabled ? {
    className: 'Mui-disabled'
  } : {}, {
    control: /*#__PURE__*/React__default['default'].createElement(MuiRadioButton, _rollupPluginBabelHelpers._extends({}, props, {
      icon: /*#__PURE__*/React__default['default'].createElement(RadioButtonIconUnchecked, null),
      checkedIcon: /*#__PURE__*/React__default['default'].createElement(RadioButtonIconChecked, null),
      onFocusVisible: function onFocusVisible() {
        return setFocusVisible(true);
      },
      onBlur: function onBlur() {
        return setFocusVisible(false);
      }
    }, props.disabled ? inactiveProps : {})),
    ref: labelRef,
    label: children
  }));
  return props.disabled && disabledReason ? /*#__PURE__*/React__default['default'].createElement(tooltip.OwnUpTooltip, {
    description: disabledReason
  }, radioButtonComponent) : radioButtonComponent;
};

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },

  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: 'row'
  }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

var FormGroup = /*#__PURE__*/React__namespace.forwardRef(function FormGroup(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$row = props.row,
      row = _props$row === void 0 ? false : _props$row,
      other = defaultTheme._objectWithoutProperties(props, ["classes", "className", "row"]);

  return /*#__PURE__*/React__namespace.createElement("div", defaultTheme._extends({
    className: withStyles.clsx(classes.root, className, row && classes.row),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? FormGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * Display group of elements in a compact row.
   */
  row: defaultTheme.PropTypes.bool
} : void 0;
var FormGroup$1 = withStyles.withStyles(styles, {
  name: 'MuiFormGroup'
})(FormGroup);

var RadioGroup = /*#__PURE__*/React__namespace.forwardRef(function RadioGroup(props, ref) {
  var actions = props.actions,
      children = props.children,
      nameProp = props.name,
      valueProp = props.value,
      onChange = props.onChange,
      other = defaultTheme._objectWithoutProperties(props, ["actions", "children", "name", "value", "onChange"]);

  var rootRef = React__namespace.useRef(null);

  var _useControlled = tooltip.useControlled({
    controlled: valueProp,
    default: props.defaultValue,
    name: 'RadioGroup'
  }),
      _useControlled2 = defaultTheme._slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  React__namespace.useImperativeHandle(actions, function () {
    return {
      focus: function focus() {
        var input = rootRef.current.querySelector('input:not(:disabled):checked');

        if (!input) {
          input = rootRef.current.querySelector('input:not(:disabled)');
        }

        if (input) {
          input.focus();
        }
      }
    };
  }, []);
  var handleRef = useIsFocusVisible.useForkRef(ref, rootRef);

  var handleChange = function handleChange(event) {
    setValue(event.target.value);

    if (onChange) {
      onChange(event, event.target.value);
    }
  };

  var name = tooltip.useId(nameProp);
  return /*#__PURE__*/React__namespace.createElement(RadioGroupContext.Provider, {
    value: {
      name: name,
      onChange: handleChange,
      value: value
    }
  }, /*#__PURE__*/React__namespace.createElement(FormGroup$1, defaultTheme._extends({
    role: "radiogroup",
    ref: handleRef
  }, other), children));
});
process.env.NODE_ENV !== "production" ? RadioGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.arrayOf(defaultTheme.PropTypes.string), defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: defaultTheme.PropTypes.string,

  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: defaultTheme.PropTypes.any
} : void 0;
var RadioGroup$1 = RadioGroup;

var _templateObject$1;
var OwnUpRadioGroupImpl = function OwnUpRadioGroupImpl(props) {
  return /*#__PURE__*/React__default['default'].createElement(RadioGroup$1, props);
};

/**
 * Container for many radio buttons where only one can be
 *   selected at a time.
 *
 */
var OwnUpRadioGroup = styled__default['default'](OwnUpRadioGroupImpl)(_templateObject$1 || (_templateObject$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  row-gap: ", "px;\n  column-gap: ", "px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(1.5);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing(1.5);
});

var _templateObject, _templateObject2;
var SearchIconButton = styled__default['default'](iconButtons.OwnUpIconButton)(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  margin: 8px;\n"])));
var searchInputHeightAndRadius = '4rem';
var SearchTextField = styled__default['default'](TextField$1)(_templateObject2 || (_templateObject2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  .MuiInputBase-input {\n    ", "\n    line-height: 1.5rem;\n    color: ", ";\n    font-size: 1rem;\n    padding-left: 28px;\n    ::placeholder {\n      opacity: 1;\n      color: ", ";\n    }\n  }\n  .MuiInputBase-root {\n    height: ", ";\n    min-width: 312px;\n    border-radius: ", ";\n    border: 1px solid ", ";\n    background-color: ", ";\n    box-shadow: 4px 4px 8px 0 rgba(29, 29, 31, 0.05);\n    &:hover {\n      box-shadow: 4px 8px 8px 0 rgba(29, 29, 31, 0.1);\n    }\n    &:focus-within {\n      border-radius: ", ";\n      ", "\n      box-shadow: 4px 8px 8px 0 rgba(29, 29, 31, 0.1);\n    }\n  }\n  &&", " {\n    outline: none;\n    .MuiInputBase-root {\n      border-radius: ", ";\n      ", "\n      box-shadow: 4px 8px 8px 0 rgba(29, 29, 31, 0.1);\n    }\n  }\n"])), monosten.aktivGroteskRegularMixin, colorPalette.CHARCOAL_100, colorPalette.SLATE_100, searchInputHeightAndRadius, searchInputHeightAndRadius, colorPalette.FOG_60, colorPalette.WHITE_100, searchInputHeightAndRadius, elementOutline.createElementOutlineMixin({
  color: colorPalette.ALOE_100,
  width: '2px',
  radius: searchInputHeightAndRadius
}), focusVisibleSelector.focusVisibleSelectorMixin, searchInputHeightAndRadius, elementOutline.createElementOutlineMixin({
  color: colorPalette.ALOE_100,
  width: '1px'
}));

var _excluded$1 = ["wrapperRef", "searchIconRef", "inputAdornmentRef", "onSearchSubmit", "icon"];
/**
 * Renders a text input search bar.
 *
 * @remarks
 * This component leverages material-ui's TextField component {@link https://mui.com/components/text-fields/}. For more detailed
 * descriptions of the parameters, visit the TextField component page{@link https://mui.com/components/text-fields/}.
 *
 * Note that any children of the search bar will be forced into a `white` theme,
 *   as the search bar has a white background.
 *
 * @param buttonClick - action event that fires when search icon button is clicked on by user
 * @param inputAdornmentRef - (optional) Pass a ref to the input adornment.
 * @param inputRef - (optional) Pass a ref to the overall input element.
 * @param onChange - (optional) Callback fired when the value is changed.
 * @param searchIconRef - (optional) Pass a ref to the div surrounding the search icon.
 * @param wrapperRef - (optional) Pass a ref to the div surrounding the entire component.
 * @returns A stylized text field component for allowing users to search for elements
 *
 */
var SearchInput = function SearchInput(_ref) {
  var wrapperRef = _ref.wrapperRef,
    searchIconRef = _ref.searchIconRef,
    inputAdornmentRef = _ref.inputAdornmentRef,
    onSearchSubmit = _ref.onSearchSubmit,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? iconLibrary_systemIcons_standardIcons_search.SearchIcon : _ref$icon,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$1);
  // Current value of the field
  var _useState = React.useState(props.value || ''),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    currentValue = _useState2[0],
    setCurrentValue = _useState2[1];
  var handleChange = function handleChange(event) {
    if (typeof event.target.value == 'string') {
      setCurrentValue(event.target.value);
    }
    if (typeof props.onChange != 'undefined') {
      props.onChange(event);
    }
  };
  var handleKeyDown = React.useCallback(function (event) {
    // A user typing 'Enter' will submit the search
    if (event.key === 'Enter' && onSearchSubmit !== undefined) {
      onSearchSubmit(currentValue);
    }
  }, [currentValue, onSearchSubmit]);
  var handleButtonClick = React.useCallback(function () {
    if (onSearchSubmit !== undefined) {
      onSearchSubmit(currentValue);
    }
  }, [currentValue, onSearchSubmit]);
  return /*#__PURE__*/React__default['default'].createElement(SearchTextField, _rollupPluginBabelHelpers._extends({
    ref: wrapperRef,
    role: "search",
    "aria-label": 'search bar container',
    tabIndex: -1,
    className: 'searchBarStyle',
    fullWidth: true,
    value: currentValue,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    InputProps: _rollupPluginBabelHelpers._objectSpread2({
      disableUnderline: true,
      placeholder: props.placeholder ? props.placeholder : 'Search',
      endAdornment:
      /*#__PURE__*/
      // Search Bars have a white background so all sub-elements are forced into the "white" theme.
      React__default['default'].createElement(element$1.OwnUpThemeProvider, {
        theme: element$1.ownUpWhiteTheme
      }, /*#__PURE__*/React__default['default'].createElement(InputAdornment$1, {
        position: "end",
        ref: inputAdornmentRef
      }, /*#__PURE__*/React__default['default'].createElement(SearchIconButton, {
        name: "Search",
        tabIndex: 0,
        onClick: handleButtonClick,
        ref: searchIconRef,
        role: "button",
        "aria-label": 'submit search query',
        icon: icon,
        size: 3
      })))
    }, props.InputProps)
  }, props));
};

var _excluded = ["id", "labelPosition", "label", "error", "$hideErrorIcon", "$endIcon", "$leadingIcon", "mainWrapperRef", "inputWrapperRef", "inputProps", "InputProps", "disabled", "FormHelperTextProps"],
  _excluded2 = ["className", "thousandSeparator", "customInput"];
var BaseTextInput = function BaseTextInput(_ref) {
  var id = _ref.id,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'inner' : _ref$labelPosition,
    label = _ref.label,
    error = _ref.error,
    $hideErrorIcon = _ref.$hideErrorIcon,
    $endIcon = _ref.$endIcon,
    $leadingIcon = _ref.$leadingIcon,
    mainWrapperRef = _ref.mainWrapperRef,
    inputWrapperRef = _ref.inputWrapperRef,
    inputProps = _ref.inputProps,
    InputProps = _ref.InputProps,
    disabled = _ref.disabled,
    FormHelperTextProps = _ref.FormHelperTextProps,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded);
  var $inputId = hooks_useElementId.useElementId(id, 'text-input');
  var labelId = "".concat($inputId, "-label");
  var builtInputProps = React.useMemo(function () {
    return _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, inputProps), {}, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'aria-labelledby': labelPosition === 'outer' ? labelId : undefined
    });
  }, [inputProps, labelId, labelPosition]);
  var renderEndAdornment = React.useMemo(function () {
    if ($endIcon) {
      return /*#__PURE__*/React__default['default'].createElement(RightSvgWrapper, null, /*#__PURE__*/React__default['default'].createElement(component.OwnUpIcon, {
        icon: $endIcon
      }));
    } else if (error && !$hideErrorIcon) {
      return /*#__PURE__*/React__default['default'].createElement(InputAdornment$1, {
        position: "end"
      }, /*#__PURE__*/React__default['default'].createElement(component.OwnUpIcon, {
        icon: iconLibrary_notificationIcons_errorLight.ErrorLightIcon
      }));
    } else {
      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null);
    }
  }, [error, $hideErrorIcon, $endIcon]);
  return /*#__PURE__*/React__default['default'].createElement(MainWrapper, {
    ref: mainWrapperRef,
    "aria-label": "textbox"
  }, labelPosition === 'inner' && $leadingIcon && /*#__PURE__*/React__default['default'].createElement(SvgWrapper, null, /*#__PURE__*/React__default['default'].createElement(component.OwnUpIcon, {
    icon: $leadingIcon
  })), /*#__PURE__*/React__default['default'].createElement(InputWrapper, {
    ref: inputWrapperRef,
    labelPosition: labelPosition,
    $leadingIcon: $leadingIcon
  }, labelPosition === 'outer' && /*#__PURE__*/React__default['default'].createElement(InputLabelText, {
    id: labelId,
    htmlFor: $inputId
  }, /*#__PURE__*/React__default['default'].createElement(element.OwnUpSmallBodyMedium, {
    variant: "body1",
    component: "span"
  }, label)), /*#__PURE__*/React__default['default'].createElement(TextInput, _rollupPluginBabelHelpers._extends({
    id: $inputId
  }, props, {
    labelPosition: labelPosition,
    $leadingIcon: $leadingIcon,
    variant: "filled",
    label: labelPosition == 'inner' && label,
    error: error,
    inputProps: builtInputProps,
    disabled: disabled
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ,
    FormHelperTextProps: _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, FormHelperTextProps), {}, {
      disabled: disabled,
      'aria-disabled': disabled
    }),
    InputProps: _rollupPluginBabelHelpers._objectSpread2(_rollupPluginBabelHelpers._objectSpread2({}, InputProps), {}, {
      startAdornment: labelPosition == 'outer' && $leadingIcon && /*#__PURE__*/React__default['default'].createElement(InputAdornment$1, {
        position: "start"
      }, /*#__PURE__*/React__default['default'].createElement(component.OwnUpIcon, {
        icon: $leadingIcon
      })),
      endAdornment: renderEndAdornment
    })
  }))));
};

/**
 * Renders a text input.
 *
 * @param props - {@see OwnUpTextInputProps}
 * @remarks This component leverages material-ui's TextField component {@link https://v4.mui.com/api/text-field}
 */
var OwnUpTextInput = function OwnUpTextInput(props) {
  return /*#__PURE__*/React__default['default'].createElement(BaseTextInput, props);
};

/**
 * Renders a number input.
 *
 * @param props - {@see OwnUpNumberInputProps}
 * @remarks This component leverages material-ui's TextField component {@link https://v4.mui.com/api/text-field}
 *   with {@link https://github.com/s-yadav/react-number-format}
 */
var OwnUpNumberInput = function OwnUpNumberInput(_ref2) {
  var className = _ref2.className,
    _ref2$thousandSeparat = _ref2.thousandSeparator,
    thousandSeparator = _ref2$thousandSeparat === void 0 ? true : _ref2$thousandSeparat,
    _ref2$customInput = _ref2.customInput,
    customInput = _ref2$customInput === void 0 ? OwnUpTextInput : _ref2$customInput,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref2, _excluded2);
  // Add a classname to the input to make it more distinguishable
  var combinedClassName = hooks_useCombinedClassName.useCombinedClassName('number-input', className);

  // Render the element
  return /*#__PURE__*/React__default['default'].createElement(NumberFormat__default['default'], _rollupPluginBabelHelpers._extends({
    className: combinedClassName,
    thousandSeparator: thousandSeparator,
    customInput: customInput
  }, props));
};

exports.OwnUpCheckbox = OwnUpCheckbox;
exports.OwnUpDropdown = OwnUpDropdown;
exports.OwnUpErrorContainer = OwnUpErrorContainer;
exports.OwnUpFilterDropdown = OwnUpFilterDropdown;
exports.OwnUpMenuItem = OwnUpMenuItem;
exports.OwnUpNumberInput = OwnUpNumberInput;
exports.OwnUpRadioButton = OwnUpRadioButton;
exports.OwnUpRadioGroup = OwnUpRadioGroup;
exports.OwnUpTextInput = OwnUpTextInput;
exports.SearchInput = SearchInput;
//# sourceMappingURL=element-c767b511.js.map
